<template>
  <div class="Bgc-white">
    <Header />
    <div class="contentContacto">
      <div class="container contacto">
        <div class="row justify-content-center">
          <div class="modify-reservation">

            <!-- Datos de estancia -->
            <b-card-group deck>
              <b-card header-tag="header" footer-tag="footer">
                <p slot="header" class="mb-0 text-right my-0">
                  <span class="infoResaltado numConfimacion">
                    {{ $t('language.posadasCorporate.reservacionesModificar.numConfirmacion') }}:
                    <span class="referencia subtitle numConfimacion">{{noConfir}}</span>
                  </span>
                </p>

                <div>
                  <p class="estancia mb-4 mt-3">
                    <i class="icon-building"></i>
                    {{ $t('language.posadasCorporate.reservacionesModificar.datosEstancia') }}
                  </p>
                </div>

                <b-collapse id="estancia" visible class="row mt-4">
                  <div class="col-12 col-lg-2">
                    <div>
                      <img class="d-inline-block mr-3" v-bind:src="hotelMainImage" :alt="altImg">
                    </div>
                  </div>
                  <div class="col-12 col-lg-10">
                    <div>
                      <p class="d-inline-block">
                        <b class="subtitle mb-0">{{hotelName}}</b>
                      </p>
                    </div>
                  </div>
                </b-collapse>
              </b-card>
            </b-card-group>

            <!-- personales -->
            <b-card-group deck>
              <b-card header-tag="header" footer-tag="footer">

                <div>
                  <p class="estancia mb-4 mt-3" v-b-toggle.personaleshuesped
                     @click="(iconoActivoDos == 1) ? iconoActivoDos = 200 : iconoActivoDos = 1">
                    <i class="icon-user"></i>
                    {{ $t('language.posadasCorporate.reservacionesModificar.datosPersonalesHuesped') }}
                    <i class="navi icon-up" :class="(iconoActivoDos == 1) ? 'oculto' : ''"></i>
                    <i class="navi icon-navigate-down"
                       :class="(iconoActivoDos == 1) ? 'camposActive' : 'oculto'"></i>
                  </p>
                </div>

                <b-collapse id="personaleshuesped" visible class="row">
                  <div class="col-12 ">
                    <div class="row">
                      <div class="col-12 col-lg-3">
                        <p class="infoResaltado mb-0">{{ $t('language.posadasCorporate.reservacionesModificar.nombreUsuario') }}</p>
                        <p class="info">{{name}}</p>
                      </div>
                      <div class="col-12 col-lg-3">
                        <p class="infoResaltado mb-0">{{ $t('language.posadasCorporate.reservacionConfirmacion.telefono') }}</p>
                        <p class="info">{{phone}}</p>
                      </div>
                      <div class="col-12 col-lg-3">
                        <p class="infoResaltado mb-0">{{ $t('language.posadasCorporate.modificacionReservaciones.correoElectronico') }}</p>
                        <p class="info">{{email}}</p>
                      </div>
                      <div class="col-12 col-lg-3">
                        <p class="infoResaltado mb-0">{{ $t('language.posadasCorporate.modificacionReservaciones.colleague') }}</p>
                        <p class="info">{{company}}</p>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </b-card>
            </b-card-group>
            
            <!-- Reserva -->
            <b-card-group deck>
              <b-card header-tag="header" footer-tag="footer">

                <div>
                  <p class="estancia mb-4 mt-3" v-b-toggle.reserva
                     @click="(iconoActivoTres == 2) ? iconoActivoTres = 300 : iconoActivoTres = 2">
                    <i class="icon-bed"></i>
                    {{ $t('language.posadasCorporate.reservacionesCancelada.text14') }}
                    <i class="navi icon-up" :class="(iconoActivoTres == 2) ? 'oculto' : ''"></i>
                    <i class="navi icon-navigate-down"
                       :class="(iconoActivoTres == 2) ? 'camposActive' : 'oculto'"></i>
                  </p>
                </div>

                <b-collapse id="reserva" visible class="row">
                  <div class="col-12 ">
                    <div class="row">
                      <div class="col-12">
                        <p class="d-inline-block mb-0"><b class="subtitle"> {{ $t('language.posadasCorporate.reservacionesModificar.modificarDatosDeEstancia.habitaciones') }}</b></p>
                      </div>
                      <div class="col-12">
                        <p class="parrafoInfo">{{roomName}}</p>
                        <ul class="listIconModal row">
                          <li class="row col-12 col-lg-4">
                            <i class="demo-icon icon-calendar col-1"></i>
                            <p class="col-10 mb-3 infoHabitacion">{{reA}} - {{reD}}<br>
                              <span class="notasInfoReserva">{{nights}} {{((nights==1)? ($t('language.posadasCorporate.reservacionesModificar.noche')) :  ($t('language.posadasCorporate.reservacionesModificar.noches'))    )}}</span></p>
                          </li>
                          <li class="row col-12 col-lg-4">
                            <i class="demo-icon icon-bed col-1"></i>
                            <p class="col-10 mb-3 infoHabitacion">{{rooms}} {{((rooms==1)? ($t('language.posadasCorporate.reservacionesModificar.habitacion')) :  ($t('language.posadasCorporate.reservacionesModificar.habitaciones'))    )}}<br>
                              <span class="notasInfoReserva">{{isNegotiated}}</span></p>
                          </li>
                          <li class="row col-12 col-lg-4">
                            <i class="demo-icon icon-user col-1"></i>
                            <p class="col-10 mb-3 infoHabitacion">{{guests}} {{((guests==1)? ($t('language.posadasCorporate.reservacionesModificar.huesped')) :  ($t('language.posadasCorporate.reservacionesModificar.huespedes'))    )}}<br>
                              <span class="notasInfoReserva">{{adults}} {{((adults==1)? ($t('language.posadasCorporate.reservacionesModificar.adulto')) :  ($t('language.posadasCorporate.reservacionesModificar.adultos'))    )}}, {{minors}} {{((minors==1)? ($t('language.posadasCorporate.reservacionesModificar.menor')) :  ($t('language.posadasCorporate.reservacionesModificar.menores'))    )}} {{y}} {{infants}} {{((infants==1)? ($t('language.posadasCorporate.reservacionesModificar.infante')) :  ($t('language.posadasCorporate.reservacionesModificar.infantes'))    )}}</span>
                            </p>
                          </li>
                        </ul>
                      </div>

                      <div >

                      <p class="col-12" v-if="banConsiEspe || descriptionMS || considEspe || banReqOpcionales"  >
                        <b
                          class="subtitle"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.suplementos')}}</b>
                      </p>
                      <!-- Consideraciones especiales-->
                      <div v-if="banConsiEspe || considEspe" class="col-12">
                        <p class="d-inline-block mb-0">
                          <b
                            class="PC-text--semibold"
                          >{{$t('language.posadasCorporate.reservacionConfirmacion.consiEspe')}}</b>
                        </p>
                        <p>
                          <span>{{considEspe}}</span>
                        </p>
                      </div>
                      <!-- Mandatorios -->
                      <div v-if="descriptionMS" class="col-12">
                        <p class="d-inline-block mb-0">
                          <b
                            class="PC-text--semibold"
                          >{{$t('language.posadasCorporate.reservacionConfirmacion.suMan')}}</b>
                        </p>
                        <p v-if="descriptionMS">
                          <span>{{descriptionMS}}</span>
                        </p>
                      </div>
           
                      <!-- Opcionales -->
                         <div v-if="banReqOpcionales" class="col-12">
                        <p class="d-inline-block mb-0">
                          <b
                            class="PC-text--semibold"
                          >{{$t('language.posadasCorporate.reservacionesRegistro.suplementosOpcionales')}}</b>
                        </p>
                                <div  v-for="(reqOpcional, index) in listRequeOpcionales" :key="'_opcional' + index">
                              <div class="d-flex flex-row">
                                <input class="mt-1 mr-2" type="checkbox" :id="'_RO' + index" @click="clicCheckBoxReqOpcional($event, reqOpcional, index)">  <!--  -->
                                <span>
                                 {{reqOpcional.numSuppleCharged }} {{reqOpcional.supplementName}}
                                </span>
                              </div>
                            </div> 
                      </div>
                      </div>

                     <div class="col-12">
                       <br>
                     </div>

                      <!-- Requerimientos -->
                      <div class="col-12">
                        <p class="d-inline-block mb-0"><b class="subtitle">{{ $t('language.posadasCorporate.reservacionesModificar.requerimientos') }}</b></p>
                      </div>
                      <div class="col-12">
                        <p class="">
                          {{ $t('language.posadasCorporate.reservacionesModificar.sinCostoAdicional') }}
                        </p>



                        <!-- Preferencias de habitacion -->
                        <div class="row mb-4">

                          <div v-if="rRe" class="form-element col-12 col-lg-6"
                               v-click-outside="outsideRoomPreferents">
                            <div v-if="(listRequeriment.habitacion===null?false:true)">

                            <label class="PC-text--size14">{{listRequeriment.habitacion.requirementType}}</label>
                            <div class="__addIcon">
                        <span
                          @click="habitacion1.roomPreferences = false">
                          <input type="text" class="inputTypeHabitaciones pointer" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                 v-model="habitacion1.typePreferent"  readonly
                                 :class="habitacion1.roomPreferences == false ? 'inputTypeHabitacionesFocus' : ''">
                        </span>
                              <div class="typeRoom card"
                                   :class="habitacion1.roomPreferences ? 'oculto' : ''">
                                <div class="d-block allRooms pb-2 mb-2">
                                  <input type="checkbox" name="allTipo" id="allTipo" v-model="selectAll"
                                         @click="habitacion1.roomPreferences = true"
                                         @change="handleType($event)">
                                  {{allRoomTypesT}}
                                </div>
                                <div class="listado-container vb" v-bar>
                                  <div>
                                    <div class="d-block"
                                         v-for="typeRoomPreferent in habitacion1.typeRoomsPreferents"
                                         :key="typeRoomPreferent.id">
                                      <input type="checkbox" v-model="habitacion1.selected"
                                             :value="typeRoomPreferent.id"
                                             @change="handleTypeSelect($event, typeRoomPreferent.name)">
                                      {{typeRoomPreferent.name}}
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                                  <p class="d-inline-block m-0 puntero"
                                     @click="[selectAll = false, habitacion1.typePreferent = '']">{{ $t('language.posadasCorporate.probAccesar.cancelButtonText') }}
                                  </p>
                                  <p class="d-inline-block m-0 text-right puntero"
                                     :class="[habitacion1.typePreferent == '' ? 'deshabilitado' : '']"
                                     @click="habitacion1.roomPreferences = true; seeRoomsP()">{{ $t('language.posadasCorporate.sidebarTop.aplicar') }}</p>
                                </div>
                              </div>
                            </div>
                            </div>
                          </div>
                          <!-- Preferencias extras -->
                          <div v-if="rRe" class="form-element col-12 col-lg-6"
                               v-click-outside="outsidePreferentsExtra">
                            <div v-if="(listRequeriment.extras===null?false:true)">
                            <label class="PC-text--size14">{{listRequeriment.extras.requirementType}}</label>
                            <div class="__addIcon">
                        <span
                          @click="habitacion1.extraPreferences = false">
                          <input type="text" class="inputTypeHabitaciones pointer" readonly :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                 v-model="habitacion1.typePreferentExtra"
                                 :class="habitacion1.extraPreferences == false ? 'inputTypeHabitacionesFocus' : ''">
                        </span>
                              <div class="typeRoom card"
                                   :class="habitacion1.extraPreferences ? 'oculto' : ''">
                                <div class="d-block allRooms pb-2 mb-2">
                                  <input type="checkbox" name="allExtrasH1" id="allExtrasH1"
                                         v-model="selectAllExtra" @click="habitacion1.extraPreferences = true"
                                         @change="handleTypeExtra($event)">
                                  {{extraPreferencesT}}
                                </div>
                                <div class="listado-container vb" v-bar>
                                  <div>
                                    <div class="d-block"
                                         v-for="typeExtraPreferent in habitacion1.typeExtrasPreferents"
                                         :key="typeExtraPreferent.id">
                                      <input type="checkbox" v-model="habitacion1.selectedExtra"
                                             :value="typeExtraPreferent.id"
                                             @change="handleTypeSelectExtra($event, typeExtraPreferent.name)">
                                      {{typeExtraPreferent.name}}
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between pt-2 mt-2 opcionesRoom">
                                  <p class="d-inline-block m-0 puntero"
                                     @click="[selectAllExtra = false, habitacion1.typePreferentExtra = '']">
                                    {{ $t('language.posadasCorporate.probAccesar.cancelButtonText') }}</p>
                                  <p class="d-inline-block m-0 text-right puntero"
                                     :class="[habitacion1.typePreferentExtra == '' ? 'deshabilitado' : '']"
                                     @click="habitacion1.extraPreferences = true; seeRoomsE()">{{ $t('language.posadasCorporate.sidebarTop.aplicar') }}</p>
                                </div>
                              </div>
                            </div>
                            </div>
                          </div>

                          <!-- Preferencias de piso -->
                          <div v-if="rRe" class="form-element col-12 col-lg-6">
                            <div v-if="(listRequeriment.piso===null?false:true)">
                              <label>{{listRequeriment.piso.requirementType}}</label><br>
                              <label  class="col-6 pl-0 radio">
                                <input @click="seeFloor(listRequeriment.piso.requirementResponseList[0].requirementCode,listRequeriment.piso.requirementResponseList[0].requirementName)" type="radio" :id="listRequeriment.piso.requirementResponseList[0].requirementCode" class="hidden" :value="listRequeriment.piso.requirementResponseList[0].requirementCode" v-model="habitacion1.pickedPiso">
                                <span class="label"></span><span class="moneda">{{listRequeriment.piso.requirementResponseList[0].requirementName}}</span>
                              </label>
                              <label v-if="listRequeriment.piso.requirementResponseList.length > 1" class="col-6 pl-0 radio">
                                <input @click="seeFloor(listRequeriment.piso.requirementResponseList[1].requirementCode,listRequeriment.piso.requirementResponseList[1].requirementName)" type="radio" :id="listRequeriment.piso.requirementResponseList[1].requirementCode" class="hidden" :value="listRequeriment.piso.requirementResponseList[1].requirementCode" v-model="habitacion1.pickedPiso">
                                <span class="label"></span><span class="moneda">{{listRequeriment.piso.requirementResponseList[1].requirementName}}</span>
                              </label>
                            </div>
                          </div>

                          <!-- Preferencias de áreas de fumar -->
                          <div v-if="rRe" class="form-element col-12 col-lg-6">
                            <div v-if="(listRequeriment.fumar===null?false:true)">
                              <label>{{listRequeriment.fumar.requirementType}}</label><br>
                              <label class="col-6 pl-0 radio">
                                <input @click="seeSmoke(listRequeriment.fumar.requirementResponseList[0].requirementCode,listRequeriment.fumar.requirementResponseList[0].requirementName)" type="radio" :id="listRequeriment.fumar.requirementResponseList[0].requirementCode" class="hidden" :value="listRequeriment.fumar.requirementResponseList[0].requirementCode" v-model="habitacion1.pickedFumar">
                                <span class="label"></span><span class="moneda">{{listRequeriment.fumar.requirementResponseList[0].requirementName}}</span>
                              </label>
                              <label v-if="listRequeriment.fumar.requirementResponseList.length > 1" class="col-6 pl-0 radio">
                                <input @click="seeSmoke(listRequeriment.fumar.requirementResponseList[1].requirementCode,listRequeriment.fumar.requirementResponseList[1].requirementName)" type="radio" :id="listRequeriment.fumar.requirementResponseList[1].requirementCode" class="hidden" :value="listRequeriment.fumar.requirementResponseList[1].requirementCode" v-model="habitacion1.pickedFumar">
                                <span class="label"></span><span class="moneda">{{listRequeriment.fumar.requirementResponseList[1].requirementName}}</span>
                              </label>
                            </div>
                          </div>

                        </div>
                      </div>
                      <div class="col-12 row justify-content-lg-end justify-content-start">
                        <div class="row col-12 col-lg-6 float-right">
                          <div class="col-6">
                            <p class="subtitle mb-0">{{ $t('language.posadasCorporate.generals.totalEstanciaImpuestos') }} {{nights}} {{(nights==1?$t('language.posadasCorporate.generals.noche'):$t('language.posadasCorporate.generals.noches'))}}:</p>
                            <span class="PC-text--size12 PC-color--grayBrownish">
                              {{rooms}} {{((rooms==1)? ($t('language.posadasCorporate.reservacionesModificar.habitacion')) :  ($t('language.posadasCorporate.reservacionesModificar.habitaciones'))    )}}
                            </span>
                          </div>
                          <div class="col-6">
                            <br><br>
                            <p class="subtitle mb-0 text-right">$ {{((ls.get('Profile').data.profileId.toLowerCase()=="pyp"||ls.get('Profile').data.profileId.toLowerCase()=="pypsa"||!ls.get('Profile').data.ratesPermissionsResponse.showRates)&&(tabActiveFR=="Tarifa Negociada"||tabActiveFR=="Negotiated Rate")?guiones: globalFunctions.numberFormat( totalCost + totalCostWithSuppl , 2, '.', ',') )   }}<span
                              class="moneda">{{currencyCode}}</span></p>
                            <p class="PC-text--size12 PC-color--grayBrownish mt-0 mb-1 text-right">
                              {{ $t('language.posadasCorporate.reservacionesModificar.ivaIncluido') }}
                            </p>
                            <p class="text-right ver-detalleInfoReserva">
                              <a class="enlaceDetalle"
                                 @click.prevent="details(); componentKey += 1" href="">
                                {{ $t('language.posadasCorporate.reservacionesModificar.verDetalle') }}
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>


              </b-card>
            </b-card-group>

            <b-card-group deck>
              <b-card header-tag="header" footer-tag="footer">
                <!-- Pago y razon social -->
                <div class="pt-8">
                  <i class="icon-currency fix-margin font-24 pr-1"></i>
                  <h3 class="estancia PC-text--size20 d-inline">{{ $t('language.posadasCorporate.reservacionesModificar.metPagoRazonSocial') }}</h3>
                  <div class="row pt-32">
                    <div class="col-12 col-lg-12">
                      <!-- Here -->
                      <div class="metodoBody" role="tablist">
                        <!-- Voucher -->
                        <div v-if="banVaucher" class="campos voucher pb-32">
                          <p class="tituloDatos" :class="(iconoActivo == 0) ? 'camposActive' : ''"
                             @click="(iconoActivo == 0) ? iconoActivo = 100 : iconoActivo = 0; sendVoucher(); generalReset()"
                             v-b-toggle="'voucher'">
                            <i class="navi"
                               :class="(iconoActivo == 0) ? 'icon-radiobutto-active' : 'icon-radiobutton-inactive'">
                            </i>
                            <i class="icon-voucher font-18"></i>
                            Voucher
                          </p>

                          <!-- Formulario -->
                          <b-collapse v-model="visibleVoucher" class="datos" id="voucher" accordion="my-accordion"
                                      role="tabpanel">
                            <div class="pt-24 pb-16">
                              <span class="PC-text--size14">{{ $t('language.posadasCorporate.reservacionesModificar.text1') }}</span>
                            </div>
                            <div class="row">

                              <!-- Folio -->
                              <div class="form-element col-12">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.numFolioCupon') }}</label>
                                <input type="text" name="" id="" v-model="vaucher.folio" @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                              </div>

                              <!-- Politica -->
                              <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchPoliticaVoucher">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.politicaViaje') }}*</label>

                                <div class="contenidoSearch" @click="[vaucher.tipoPolitica = true]">
                                  <i class="search-icons icon-unfold-more"
                                     v-if="!vaucher.tipoPolitica"></i>
                                  <i class="search-icons icon-close pointer"
                                     v-if="vaucher.tipoPolitica" @click="vaucher.politicaSeleccionada = '', filteredPolilticas()"></i>
                                  <input class="elipse" type="text" @paste="handlePaste" onkeypress="return (event.charCode != 124)" @keyup="filteredPolilticas()" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                         @click="filteredListPoliticasVoucher()"
                                         v-model="vaucher.politicaSeleccionada">
                                </div>
                                <div class="card buscadorCard vb" v-if="vaucher.tipoPolitica" v-bar>
                                  <div>
                                    <div class="buscador" v-for="politica in vaucher.politicasLista"
                                         :key="politica.id">
                                      <p class="mb-1 nombre"
                                         @click="[cambiaValuePoliticaVoucher(politica.nombre, politica.code), vaucher.tipoPolitica = 0]"
                                         v-html="$options.filters.resalt( politica.nombre , vaucher.politicaSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Razon -->
                              <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchRazonVoucher">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.razonSocial') }}*</label>
                                <div class="contenidoSearch" @click="[vaucher.tipoRazon = true]">
                                  <i class="search-icons icon-unfold-more"
                                     v-if="!vaucher.tipoRazon"></i>
                                  <i class="search-icons icon-close pointer"
                                     v-if="vaucher.tipoRazon"></i>
                                  <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                         @click="filteredListRazonesVoucher()"
                                         v-model="vaucher.razonSeleccionada" readonly>
                                </div>
                                <div class="card buscadorCard vb" v-if="vaucher.tipoRazon" v-bar>
                                  <div>
                                    <div class="buscador" v-for="perfil in vaucher.razonesLista"
                                         :key="perfil.id">
                                      <p class="mb-1 nombre"
                                         @click="[cambiaValueRazonVoucher(perfil.nombre, perfil.razonSe), vaucher.tipoRazon = 0, businessRa = perfil.razonSe]"
                                         v-html="$options.filters.resalt( perfil.nombre , vaucher.razonSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-collapse>
                        </div>
                        <hr>
                        <!-- Tarjeta de crédito -->
                        <div v-if="banTarjCred" class="campos py-32">
                          <p class="tituloDatos" :class="(iconoActivo == 1) ? 'camposActive' : ''"
                             @click="(iconoActivo == 1) ? iconoActivo = 100 : iconoActivo = 1; sendCreditCard(); generalReset(); modalToken(1)"
                             v-b-toggle="'credito'" accordion="my-accordion" role="tabpanel">
                            <i class="navi"
                               :class="(iconoActivo == 1) ? 'icon-radiobutto-active' : 'icon-radiobutton-inactive'">
                            </i>
                            <i class="icon-credit-card font-18"></i>
                            {{ $t('language.posadasCorporate.reservacionesModificar.tarjetaCredito') }}
                          </p>

                          <!-- Formulario -->
                          <b-collapse v-model="visibleTC" class="datos" id="credito" accordion="my-accordion"
                                      role="tabpanel">
                            <div class="pt-24 pb-16">
                              <div class="PC-text--size14">
                                {{ $t('language.posadasCorporate.reservacionesModificar.text2') }}
                              </div>
                            </div>
                            <div class="row">

                              <!-- Tipo de tarjeta* -->
                              <div class="form-element col-12 col-lg-6 m-0">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.tarjetaCredito') }}*</label>
                                <div class="contenidoSearch" @click="[credito.tipoTarjeta = true]"
                                     v-click-outside="outsideCredito">
                                  <i class="search-icons icon-unfold-more"
                                     v-if="!credito.tipoTarjeta"></i>
                                  <i class="search-icons icon-close pointer"
                                     v-if="credito.tipoTarjeta"
                                     @click="credito.tarjetaSeleccionada = ''"></i>
                                  <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                         @click="filteredListCredito()"
                                         v-model="credito.tarjetaSeleccionada" onlyread @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                                </div>
                                <div class="card buscadorCard vb" v-if="credito.tipoTarjeta" v-bar>
                                  <div>
                                    <div class="buscador"
                                         v-for="tipoTarjeta in credito.tarjetasLista"
                                         :key="tipoTarjeta.id">
                                      <p class="mb-1 nombre"
                                         @click="[cambiaCredito(tipoTarjeta.nombre), cambiarMascara(tipoTarjeta.tipoT), tipoTarjeta = 0, credito.tipoTarjeta = false]"
                                         v-html="$options.filters.resalt( tipoTarjeta.nombre , credito.tarjetaSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Tarjeta* -->
                              <div class="form-element col-12 col-lg-6 mt-0">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.numeroTarjeta') }}*</label>
                                <div class="contenidoSearchCard" @click.prevent="abrirTokenizador()">
                                  <i class="search-iconsCards icon-credit-card"></i>
                                  <input type="text" class="elipseCards" v-model="credito.numero" :disabled="isDisabledTokenizador" @paste="handlePaste"  onkeypress="return (event.charCode != 124)">

                                </div>
                              </div>
                              <!-- INICIA MODAL NO PUBLICAS Y NO NEGOCIADAS -->
                              <modal v-show="modalTokenizador" @close="cerrarTokenizador()" maxWidth="max-w-500">
                                <template slot="header">
                                  <b></b>
                                </template>
                                <template slot="body">
                                  <div v-html="HTMLcontent">
                                  </div>
                                </template>
                                <template slot="footer">
                                  <b></b>
                                </template>
                              </modal>

                              <!-- Nombre de tarjetahabiente* -->
                              <div class="form-element col-12 col-lg-8">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.nombreTarjetahabiente') }}*</label>
                                <input class="mayuscula" type="text" v-onlyText v-model="credito.nombre" @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                              </div>
                              <!-- Fecha de expiración* -->
                              <div class="form-element col-12 col-lg-4">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.fechaExpiracion') }}*</label>
                                <cleave
                                  :class="{ 'is-invalid': (banTarCredExp)}"
                                  v-model="fechaExpiracionTarCred"
                                  :raw="false"
                                  :options="options.date"
                                  placeholder="MM/AAAA">
                                </cleave>
                                <span class="notas" v-if="credito.expiracion.length > 0 && credito.expiracion.length < 7" >
                                    {{$t('language.posadasCorporate.paymentMethods.text41')}}
                                  </span>
                                <span v-if="banTarCredExp && credito.expiracion.length == 7 && validDateExpirationTarCred.tipoError === 2" class="notas">{{$t('language.posadasCorporate.paymentMethods.text43')}}</span>
                                <span v-if="banTarCredExp && credito.expiracion.length == 7 && validDateExpirationTarCred.tipoError === 1" class="notas">{{$t('language.posadasCorporate.paymentMethods.text44')}}</span>
                              </div>
                              <!-- Politica -->
                              <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchPoliticaCredito">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.politicaViaje') }}</label>

                                <div class="contenidoSearch" @click="[credito.tipoPolitica = true]">
                                  <i class="search-icons icon-unfold-more"
                                     v-if="!credito.tipoPolitica"></i>
                                  <i class="search-icons icon-close pointer"
                                     v-if="credito.tipoPolitica" @click="credito.politicaSeleccionada = '', filteredPolilticas()"></i>
                                  <input class="elipse" type="text" @keyup="filteredPolilticas()" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                         @click="filteredListPoliticasCredito()"
                                         v-model="credito.politicaSeleccionada" @paste="handlePaste"  onkeypress="return (event.charCode != 124)">
                                </div>
                                <div class="card buscadorCard vb" v-if="credito.tipoPolitica" v-bar>
                                  <div>
                                    <div class="buscador" v-for="politica in credito.politicasLista"
                                         :key="politica.id">
                                      <p class="mb-1 nombre"
                                         @click="[cambiaValuePoliticaCredito(politica.nombre), credito.tipoPolitica = 0]"
                                         v-html="$options.filters.resalt( politica.nombre , credito.politicaSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Razon -->
                              <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchRazonCredito">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.razonSocial') }}</label>
                                <div class="contenidoSearch" @click="[credito.tipoRazon = true]">
                                  <i class="search-icons icon-unfold-more"
                                     v-if="!credito.tipoRazon"></i>
                                  <i class="search-icons icon-close pointer"
                                     v-if="credito.tipoRazon"></i>
                                  <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                         @click="filteredListRazonesCredito()"
                                         v-model="credito.razonSeleccionada" readonly>
                                </div>
                                <div class="card buscadorCard vb" v-if="credito.tipoRazon" v-bar>
                                  <div>
                                    <div class="buscador" v-for="perfil in credito.razonesLista"
                                         :key="perfil.id">
                                      <p class="mb-1 nombre"
                                         @click="[cambiaValueRazonCredito(perfil.nombre), credito.tipoRazon = 0, businessRa = perfil.razonSe]"
                                         v-html="$options.filters.resalt( perfil.nombre , credito.razonSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-collapse>
                        </div>

                        <hr>

                        <!-- Token -->
                        <div  v-if="banToken" class="campos py-32">
                          <p class="tituloDatos" :class="(iconoActivo == 2) ? 'camposActive' : ''"
                             @click="(iconoActivo == 2) ? iconoActivo = 100 : iconoActivo = 2; sendToken(); generalReset(); modalToken(2)"
                             v-b-toggle="'token'" accordion="my-accordion" role="tabpanel">
                            <i class="navi"
                               :class="(iconoActivo == 2) ? 'icon-radiobutto-active' : 'icon-radiobutton-inactive'">
                            </i>
                            <i class="icon-key font-18"></i>
                            Token
                          </p>

                          <!-- Formulario -->
                          <b-collapse v-model="visible" class="datos" id="token" accordion="my-accordion"
                                      role="tabpanel" >
                            <div class="pt-24 pb-16">
                              <span class="PC-text--size14">
                                {{ $t('language.posadasCorporate.reservacionesModificar.text3') }}
                              </span>
                            </div>
                            <div class="row">

                              <!-- Tipo de tarjeta* -->
                              <div class="form-element col-12 col-lg-6 m-0">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.tarjetaCredito') }}*</label>
                                <div class="contenidoSearch" @click="[token.tipoTarjeta = true]"
                                     v-click-outside="outsideToken">
                                  <i class="search-icons icon-unfold-more"
                                     v-if="!token.tipoTarjeta"></i>
                                  <i class="search-icons icon-close pointer"
                                     v-if="token.tipoTarjeta"
                                     @click="token.tarjetaSeleccionada = ''"></i>
                                  <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                         @click="filteredListToken()"  @paste="handlePaste" onkeypress="return (event.charCode != 124)"
                                         v-model="token.tarjetaSeleccionada">
                                </div>

                                <div class="card buscadorCard vb" v-if="token.tipoTarjeta" v-bar>
                                  <div>
                                    <div class="buscador" v-for="tipoTarjeta in token.tarjetasLista"
                                         :key="tipoTarjeta.id">
                                      <p class="mb-1 nombre"
                                         @click="[cambiaToken(tipoTarjeta.nombre), tipoTarjeta = 0, token.tipoTarjeta = false]"
                                         v-html="$options.filters.resalt( tipoTarjeta.nombre , token.tarjetaSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Número de tarjeta* -->
                              <div class="form-element col-12 col-lg-6 mt-0">
                                <label>Token</label>
                                <div class="contenidoSearchCard">
                                  <i class="search-iconsCards icon-key"></i>
                                  <input type="text" class="elipseCards" v-model="token.numero"
                                         placeholder="0000000000000000" :disabled="isDisabledTokenizador" v-uppercase v-alphanumeric  @paste="handlePaste" maxlength="16" onkeypress="return (event.charCode != 124)"/>
                                </div>

                              </div>
                              <!-- Nombre de tarjetahabiente* -->
                              <div class="form-element col-12 col-lg-8">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.nombreTarjetahabiente') }}*</label>
                                <input class="mayuscula" type="text" v-onlyText v-model="token.nombre" @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                              </div>
                              <!-- Fecha de expiración* -->
                              <div class="form-element col-12 col-lg-4">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.fechaExpiracion') }}*</label>
                                <cleave
                                  :class="{ 'is-invalid': (banTokenExp)}"
                                  v-model="fechaExpiracionToken"
                                  :raw="false"
                                  :options="options.date"
                                  placeholder="MM/AAAA">
                                </cleave>
                                <span class="notas" v-if="token.expiracion.length > 0 && token.expiracion.length < 7" >
                                    {{$t('language.posadasCorporate.paymentMethods.text41')}}
                                  </span>
                                <span v-if="banTokenExp && token.expiracion.length == 7 && validDateExpirationToken.tipoError === 2" class="notas">{{$t('language.posadasCorporate.paymentMethods.text42')}}</span>
                                <span v-if="banTokenExp && token.expiracion.length == 7 && validDateExpirationToken.tipoError === 1" class="notas">{{$t('language.posadasCorporate.paymentMethods.text44')}}</span>
                              </div>
                              <!-- Politica -->
                              <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchPoliticaToken">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.politicaViaje') }}</label>

                                <div class="contenidoSearch" @click="[token.tipoPolitica = true]">
                                  <i class="search-icons icon-unfold-more" v-if="!token.tipoPolitica"></i>
                                  <i class="search-icons icon-close pointer" v-if="token.tipoPolitica" @click="token.politicaSeleccionada = '', filteredPolilticas()"></i>
                                  <input class="elipse" type="text" @keyup="filteredPolilticas()" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                         @click="filteredListPoliticasToken()"
                                         v-model="token.politicaSeleccionada" @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                                </div>

                                <div class="card buscadorCard vb" v-if="token.tipoPolitica" v-bar>
                                  <div>
                                    <div class="buscador" v-for="politica in token.politicasLista"
                                         :key="politica.id">
                                      <p class="mb-1 nombre"
                                         @click="[cambiaValuePoliticaToken(politica.nombre), token.tipoPolitica = 0]"
                                         v-html="$options.filters.resalt( politica.nombre , token.politicaSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Razon -->
                              <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchRazonToken">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.razonSocial') }}</label>
                                <div class="contenidoSearch" @click="[token.tipoRazon = true]">
                                  <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                         @click="filteredListRazonesToken()"
                                         v-model="token.razonSeleccionada" readonly>
                                </div>

                                <div class="card buscadorCard vb" v-if="token.tipoRazon" v-bar>
                                  <div>
                                    <div class="buscador" v-for="perfil in token.razonesLista"
                                         :key="perfil.id">
                                      <p class="mb-1 nombre"
                                         @click="[cambiaValueRazonToken(perfil.nombre), token.tipoRazon = 0,  businessRa = perfil.razonSe]"
                                         v-html="$options.filters.resalt( perfil.nombre , token.razonSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-collapse>
                        </div>

                        <hr>

                        <!-- Tiempo límite -->
                        <div v-if="banTiemLim" class="campos limite py-32">
                          <p class="tituloDatos" :class="(iconoActivo == 3) ? 'camposActive' : ''"
                             @click="(iconoActivo == 3) ? iconoActivo = 100 : iconoActivo = 3; sendTimeLimit(); generalReset()"
                             v-b-toggle="'tiempoLimite'" accordion="my-accordion" role="tabpanel">
                            <i class="navi"
                               :class="(iconoActivo == 3) ? 'icon-radiobutto-active' : 'icon-radiobutton-inactive'">
                            </i>
                            <i class="icon-time font-18"></i>
                            {{ $t('language.posadasCorporate.reservacionesModificar.tiempoLimite') }}
                          </p>

                          <!-- Formulario -->
                          <b-collapse v-model="visibleLimit" class="datos" id="tiempoLimite" accordion="my-accordion"
                                      role="tabpanel">
                            <div class="pt-24 pb-16">
                              <span class="PC-text--size14">
                                {{ $t('language.posadasCorporate.reservacionesModificar.text4') }}
                              </span>
                            </div>
                            <div class="row">

                              <!-- Politica -->
                              <div class="form-element col-12 col-lg-6 mt-0" v-click-outside="outsideSearchPoliticaTiempo">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.politicaViaje') }}</label>

                                <div class="contenidoSearch"
                                     @click="[tiempoLimite.tipoPolitica = true]">
                                  <i class="search-icons icon-unfold-more"
                                     v-if="!tiempoLimite.tipoPolitica"></i>
                                  <i class="search-icons icon-close pointer"
                                     v-if="tiempoLimite.tipoPolitica" @click="tiempoLimite.politicaSeleccionada = '', filteredPolilticas()"></i>
                                  <input class="elipse" type="text" @keyup="filteredPolilticas()" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                         @click="filteredListPoliticasTiempo()"
                                         v-model="tiempoLimite.politicaSeleccionada" @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                                </div>
                                <div class="card buscadorCard vb" v-if="tiempoLimite.tipoPolitica"
                                     v-bar>
                                  <div>
                                    <div class="buscador"
                                         v-for="politica in tiempoLimite.politicasLista"
                                         :key="politica.id">
                                      <p class="mb-1 nombre"
                                         @click="[cambiaValuePoliticaTiempo(politica.nombre), tiempoLimite.tipoPolitica = 0]"
                                         v-html="$options.filters.resalt( politica.nombre , tiempoLimite.politicaSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Razon -->
                              <div class="form-element col-12 col-lg-6 mt-0" v-click-outside="outsideSearchRazonTiempo">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.razonSocial') }}</label>
                                <div class="contenidoSearch"
                                     @click="[tiempoLimite.tipoRazon = true]">
                                  <i class="search-icons icon-unfold-more"
                                     v-if="!tiempoLimite.tipoRazon"></i>
                                  <i class="search-icons icon-close pointer"
                                     v-if="tiempoLimite.tipoRazon"></i>
                                  <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                         @click="filteredListRazonesTiempo()"
                                         v-model="tiempoLimite.razonSeleccionada" readonly>
                                </div>
                                <div class="card buscadorCard vb" v-if="tiempoLimite.tipoRazon"
                                     v-bar>
                                  <div>
                                    <div class="buscador"
                                         v-for="perfil in tiempoLimite.razonesLista" :key="perfil.id">
                                      <p class="mb-1 nombre"
                                         @click="[cambiaValueRazonTiempo(perfil.nombre), tiempoLimite.tipoRazon = 0,  businessRa = perfil.razonSe]"
                                         v-html="$options.filters.resalt( perfil.nombre , tiempoLimite.razonSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-collapse>
                        </div>

                        <hr>

                        <!-- Credito -->
                        <div v-if="banCredito" class="campos voucher py-32">
                          <p class="tituloDatos" :class="(iconoActivo == 4) ? 'camposActive' : ''"
                             @click="(iconoActivo == 4) ? iconoActivo = 100 : iconoActivo = 4;sendCreditPay() ; generalReset()"
                             v-b-toggle="'creditoEmpresa'">
                            <i class="navi"
                               :class="(iconoActivo == 4) ? 'icon-radiobutto-active' : 'icon-radiobutton-inactive'">
                            </i>
                            <i class="icon-currency"></i>
                            {{ $t('language.posadasCorporate.reservacionesModificar.credito') }}
                          </p>

                          <!-- Formulario -->
                          <b-collapse v-model="visibleCredit" class="datos" id="creditoEmpresa" accordion="my-accordion"
                                      role="tabpanel">
                            <div class="pt-24 pb-16">
                              <span class="PC-text--size14">
                               {{ $t('language.posadasCorporate.reservacionesModificar.text5') }}
                              </span>
                            </div>
                            <div class="row">

                              <!-- Folio -->
                              <div class="form-element col-12">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.numFolioCupon') }}</label>
                                <input type="text" name="" id="" v-model="creditoEmpresa.folio" @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                              </div>

                              <!-- Politica -->
                              <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchPoliticaCreditoEmpresa">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.politicaViaje') }}*</label>

                                <div class="contenidoSearch"
                                     @click="[creditoEmpresa.tipoPolitica = true]">
                                  <i class="search-icons icon-unfold-more"
                                     v-if="!creditoEmpresa.tipoPolitica"></i>
                                  <i class="search-icons icon-close pointer"
                                     v-if="creditoEmpresa.tipoPolitica" @click="creditoEmpresa.politicaSeleccionada = '', filteredPolilticas()"></i>
                                  <input class="elipse" type="text" @keyup="filteredPolilticas()" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                         @click="filteredListPoliticasCreditoEmpresa()"
                                         v-model="creditoEmpresa.politicaSeleccionada" @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                                </div>

                                <div class="card buscadorCard vb" v-if="creditoEmpresa.tipoPolitica"
                                     v-bar>
                                  <div>
                                    <div class="buscador"
                                         v-for="politica in creditoEmpresa.politicasLista"
                                         :key="politica.id">
                                      <p class="mb-1 nombre"
                                         @click="[cambiaValuePoliticaCreditoEmpresa(politica.nombre, politica.code), creditoEmpresa.tipoPolitica = 0]"
                                         v-html="$options.filters.resalt( politica.nombre , creditoEmpresa.politicaSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Razon -->
                              <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchRazonCreditoEmpresa">
                                <label>{{ $t('language.posadasCorporate.reservacionesModificar.razonSocial') }}*</label>

                                <div class="contenidoSearch"
                                     @click="[creditoEmpresa.tipoRazon = true]">
                                  <i class="search-icons icon-unfold-more"
                                     v-if="!creditoEmpresa.tipoRazon"></i>
                                  <i class="search-icons icon-close pointer"
                                     v-if="creditoEmpresa.tipoRazon"></i>
                                  <input class="elipse" type="text" :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                                         @click="filteredListRazonesCreditoEmpresa()"
                                         v-model="creditoEmpresa.razonSeleccionada" readonly>
                                </div>

                                <div class="card buscadorCard vb" v-if="creditoEmpresa.tipoRazon"
                                     v-bar>
                                  <div>
                                    <div class="buscador"
                                         v-for="perfil in creditoEmpresa.razonesLista"
                                         :key="perfil.id">
                                      <p class="mb-1 nombre"
                                         @click="[cambiaValueRazonCreditoEmpresa(perfil.nombre, perfil.code), creditoEmpresa.tipoRazon = 0,  businessRa = perfil.razonSe]"
                                         v-html="$options.filters.resalt( perfil.nombre , creditoEmpresa.razonSeleccionada)">
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </b-collapse>
                        </div>
                      </div>
                      <!-- end here -->
                    </div>

                  </div>

                </div>
              </b-card>
            </b-card-group>

            <!-- politica de cambio y cancelacion -->
            <b-card-group deck>
              <b-card header-tag="header" footer-tag="footer">

                <div class="col-12 row align-items-center p-0 m-0" v-b-toggle.politicasCambio
                     @click="(iconoActivoSiete == 6) ? iconoActivoSiete = 700 : iconoActivoSiete = 6">
                  <div class="pl-0 col-lg-8 col-11">
                    <p class="estancia mb-3 mb-lg-4 mt-3">
                      <i class="icon-politics"></i>
                      {{ $t('language.posadasCorporate.reservacionConfirmacion.politicasCancelacion') }}
                    </p>
                  </div>
                  <div class="col-lg-3 d-none d-lg-block pr-0">
                  </div>
                  <div class="col-1 pr-0 pl-0">
                    <i class="navi icon-up " :class="(iconoActivoSiete == 6) ? 'oculto' : ''"></i>
                    <i class="navi icon-navigate-down "
                       :class="(iconoActivoSiete == 6) ? 'camposActive' : 'oculto'"></i>
                  </div>
                </div>
                <div class="pr-0 d-lg-none d-block">
                  <p class="mb-4 mt-3 azul">{{ $t('language.posadasCorporate.reservacionConfirmacion.goOn') }}<i class="icon-report"></i></p>
                </div>

                <b-collapse id="politicasCambio" visible class="row">


                  <!-- Limite 
                  <div class="col-12 " v-for="(politicas, index) in HotelDetailDataPoliticas" :key="'politicas_'+index">-->
                  <div class="col-12 "  v-for="(politicas, index) of datosHabHotSelected.politicas.listPoliticas" :key="'politicas'+index">
                 
                    <div class="row">
                      <div class="col-12">
                        <p  class="subtitle"
                            :class="(iconoNaviActivo == index) ? 'camposActive' : ''"
                            @click="(iconoNaviActivo == index) ? iconoNaviActivo = 100 : iconoNaviActivo = index"
                            v-b-toggle="'togle'+index">
                          {{politicas.title}}
                          <i class="navi icon-up" :class="(iconoNaviActivo == index) ? 'camposActive' : 'oculto'"></i>
                          <i class="navi icon-navigate-down" :class="(iconoNaviActivo == index) ? 'oculto' : ''"></i>
                        </p>
                      </div>

                      <!-- Formulario -->
                      <b-collapse class="col-12" v-bind:id="'togle'+index" >
                        <div class="row">

                          <div class="col-12">
                            <p>
                                <!-- KB48764 By m.a.cortes -->                     
                              {{changePolicy(politicas.description,politicas.penaltyQuantity,guiones,tabActiveFR,ls.get('Profile').data.profileId.toLowerCase())}}
                            </p>
                          </div>
                        </div>
                      </b-collapse>

                    </div>
                    <hr v-if="index !== HotelDetailDataPoliticas.length-1">
                  </div>
                  <!-- No llegada -->
                  <div class="col-12">
                    <div class="row">

                      <div class="col-12">
                        <div class="d-flex flex-row">
                          <input class="mt-1 mr-2" type="checkbox" v-model="aceptoAviso" @click="modalCheckbox()" :disabled="isDisabledCheckbox">
                          <span class="custom-IE">
                            {{$t('language.posadasCorporate.paymentMethods.text37')}}
                            <span class="notaAzul cursor" @click="redirecAvisoPrivacidad">{{$t('language.posadasCorporate.reservacionesRegistro.privacy')}}.</span>*
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </b-card>
            </b-card-group>
            <Loader v-if="changeLoader"/>

            <!-- Botones -->
            <div class="row">
              <div class="col-lg-12 col-12 mb-5">
                <div class="row flex-end">
                  <div class="col-12 col-lg-6 order-1 order-lg-2 mb-3 mb-lg-0">
                    <button type="button" class="mt-3 button" :disabled="isDisabled"
                            value="Guardar modificaciones" @click="changeResCon()">{{ $t('language.posadasCorporate.reservacionesModificar.confirChan') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-popover target="tipo-tarifa-info" triggers="hover focus" placement="bottom"
               customClass="PC-popover"
               content="Te recomendamos verificar la hora de check-in y check-out en el hotel (early check-in y check-out late puede incurrir en costos adicionales). Este dato es sólo informativo y está sujeto a disponibilidad.">
    </b-popover>
    <b-popover target="info" triggers="hover focus" placement="bottom" customClass="PC-popover"
               content="Te recomendamos verificar la hora de check-in y check-out en el hotel (early check-in y check-out late puede incurrir en costos adicionales). Este dato es sólo informativo y está sujeto a disponibilidad.">
    </b-popover>

    <DetalleCostos :key="componentKey"></DetalleCostos>
    <Footer />



    <!-- EXPIRED SESSION MODAL  -->
    <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution">
          <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{ $t('language.posadasCorporate.modales.expiredSession.title') }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">{{ $t('language.posadasCorporate.modales.expiredSession.body') }}</p>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="button btn-primary"
          @click="closeExpiredModal"
          aria-label="Close modal"
        >{{ $t('language.posadasCorporate.modales.expiredSession.button') }}</button>
      </template>
    </modal>
    <!-- EXPIRED SESSION MODAL  -->

    <modal v-if="banModalTokenInexistente" @close="banModalTokenInexistente = false" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.paymentMethods.modales.tokenInexistente.title')}}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{$t('language.posadasCorporate.paymentMethods.modales.tokenInexistente.body')}}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="primary-button" @click="banModalTokenInexistente = false" aria-label="Close modal">
          {{$t('language.posadasCorporate.paymentMethods.modales.tokenInexistente.button')}}
        </button>
      </template>
    </modal>

    <modal v-show="isModalVisibleUsarToken" @close="closeModalToken" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{modalTokenCredito.title}}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{modalTokenCredito.body}}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="secondary-button" @click="closeModalToken" aria-label="Close modal">
          {{$t('language.posadasCorporate.paymentMethods.modales.usarToken.no')}}
        </button>
        <button type="button" class="primary-button" @click="modalTokenCreditYes()" aria-label="Close modal">
          {{$t('language.posadasCorporate.paymentMethods.modales.usarToken.si')}}
        </button>
      </template>
    </modal>

    <modal v-show="isModalVisible" @close="closeModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{modalTokenCreditoSaveUpdate.title}}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{modalTokenCreditoSaveUpdate.body}}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="secondary-button" @click="modalSaveUpdate(2)" aria-label="Close modal">
          {{$t('language.posadasCorporate.paymentMethods.modales.usarToken.noGuardar')}}
        </button>
        <button type="button" class="primary-button" @click="modalSaveUpdate(1)" aria-label="Close modal">
          {{$t('language.posadasCorporate.paymentMethods.modales.usarToken.guardar')}}
        </button>
      </template>
    </modal>

    <modal v-if="banNewModal" @close="closeModalNew" maxWidth="max-w-500">
      <template slot="header">
        <b class="danger"> <i class="icon-close-rounded-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.reservacionesModificar.modalError.error') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ modalNewBody }}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary" @click="closeModalNew"
          aria-label="Close modal">
          {{ $t('language.posadasCorporate.reservacionesModificar.modalError.entendido') }}
        </button>
      </template>
    </modal>

    <modal v-if="modalCaution" @close="modalCaution = false" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.modales.pasConfirmation.title') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ modalCautionBody }}
        </p>
      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary" @click="modalCaution = false"
                aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.pasConfirmation.button') }}
        </button>
      </template>
    </modal>

    <modal v-if="banError6" @close="error6Modal" maxWidth="max-w-500">
    <template slot="header">
      <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.modales.pasConfirmation.title') }}</b>
    </template>
    <template slot="body">
      <p class="Ta-left">
        {{ error6Body }}
      </p>
    </template>
    <template slot="footer">

      <button type="button" class="button btn-primary" @click="error6Modal"
              aria-label="Close modal">
        {{ $t('language.posadasCorporate.modales.pasConfirmation.button') }}
      </button>
    </template>
  </modal>

  </div>
</template>

<script>
  import * as GlobalServices from '../../../utils/GlobalServices';
  import * as GlobalFunctions from '../../../utils/GlobalFunctions';
  import Modal from '../../addons/Modal.vue'

  import Header from '../../generales/Header.vue';
  import Footer from '../../generales/Footer.vue';
  import DetalleCostos from '../DetalleCostos';
  import axios from 'axios';
  import i18n from '../../../plugins/i18n';
  import Loader from '../../loader/Loader';
  import SecureLS from 'secure-ls';
  import Cleave from 'vue-cleave-component';
  export default {
    name: 'ReservacionesConfirmacion',
    components: {
      Header,
      Footer,
      DetalleCostos,
      Loader,
      Modal,
      Cleave
    },
    data: () => {
      return {
        amountWithoutTaxes: null,
        amoutString: '',
        banError6: false,
        error6Body: '',
        modalCaution: false,
        modalCautionBody: '',
        isUserGeneric: false,
        politicasList: [],
        banSelectedPoliticaVaucher: false,
        banSelectedPoliticaCredito: false,
        banSelectedPoliticaToken: false,
        banSelectedPoliticaCreditoEmpresa: false,
        banSelectedPoliticaTiempoLimite: false,
        guiones: "------",
        twoPolicy: 'igual a 2',
        twoPolicyEn: 'equal to 2',
        tabActiveFR: "",
        modalNewBody: '',
        banNewModal: false,
        validDateExpirationTarCred: null,
        validDateExpirationToken: null,
        globalFunctions: GlobalFunctions,
        totalCostWithSuppl : 0,
        totalSupplTax : 0,
        totalSuppAmou : 0,
        listRequeOpcionalesSeleccionados: [],
        listRequeOpcionales: [],
        banReqOpcionales: true,
        descriptionMS: "",
        banConsiEspe: false,
        considEspe: '',
        contPoliticaSelectedDefault: 0,
        banPoliticaSelectedDefault: false,
        contRazonSelectedDefault: 0,
        banRazonSelectedDefault: false,
        banIsTokenGuardado: false,
        reA: "",
        reD: "",
        businessRa: "",
        fechaExpiracionTarCred: '',
        fechaExpiracionToken: '',
        banTarCredExp: false,
        banTokenExp: false,
        options: {
          date: {
            date: true,
            datePattern: ['m', 'Y'],
            delimiter: '/',
          },
        },
        banModalTokenInexistente: false,
        banTokenInexistente: false,
        dataCard: '',
        dataTokenExist: null,
        modalTokenCredito: {
          title: null,
          body: null,
          modalNumberToken: null,
          lugar: null
        },
        saveOrUpdate: '',
        isModalVisibleUsarToken: false,
        isModalVisible: false,
        modalTokenCreditoSaveUpdate: {
          title: null,
          body: null
        },
        textPref: "",

        seeTextSmoke: "",
        seeTextFloor: "",
        mergeUpdate: false,
        arraySmoke: [],
        arrayFloors: [],
        totalPreferencesRoomsWS: [],

        addF: false,
        addS: false,
        extraPreferencesT : "Todas las preferencias extras",
        allRoomTypesT: "Todas las preferencias de habitación",
        rRe: false,
        totalPreferences: [],
        listRequeriment: [],
        totalPrefTexto: null,
        arraySmoke: null,
        arrayFloors: null,
        requirementsByCode: null,

        habitacion1: {
          // tipos de Piso
          pickedPiso: "bajo",
          // Área de fumar
          pickedFumar: "",
          typePreferent: 'Ver preferencias de habitación seleccionadas',
          roomPreferences: true,
          typeRoomsPreferents: [
          ],
          selected: [],
          showRoomTypeMobile: false,
          //tipo de preferencia extra
          typePreferentExtra: 'Todas las preferencias extras',
          extraPreferences: true,
          typeExtrasPreferents: [
          ],
          selectedExtra: [],
          showExtraTypeMobile: false,
        },
        preTe: "",
        isCreditPayment: false,
        isTimeLimitPayment: false,
        isTokenPayment: false,
        isCreditCardPayment: false,
        isVoucherPayment: false,
        HotelDetailDataPoliticas:[],
        changeLoader: false,
        modalTokenizador: false,
        HTMLcontent: '',
        urlTokenizado: '',
        banVaucher : false,
        banTarjCred : false,
        banToken : false,
        banTiemLim : false,
        banCredito : false,
        visible: false,
        visibleVoucher: false,
        visibleTC: false,
        visibleLimit: false,
        visibleCredit: false,
        banDetCost: false,
        componentKey: 0,
        ls: new SecureLS({ encodingType: "aes" }),
        isExpiredModalVisible: false,
        currencyCode: "MXN",
        totalCost: 0,
        isNegotiated: "",
        roomName: "",
        arrivalDate: "",
        departureDate: "",
        nights: 1,
        rooms: 1,
        guests: 1,
        adults: 1,
        minors: 1,
        infants: 1,
        hotelMainImage: "",
        noConfir: "",
        phone: "----",
        email: "",
        company: "",
        data: "",
        altImg: "",
        hotelName: "",
        iconoActivoUno: null,
        iconoActivoDos: null,
        iconoActivoTres: null,
        iconoActivoCuatro: null,
        iconoActivoCinco: null,
        iconoActivoSeis: null,
        iconoActivoSiete: null,
        iconoNaviActivo: null,
        iconoNaviActivoUno: null,
        iconoNaviActivoDos: null,
        iconoNaviActivoTres: null,
        iconoNaviActivoCuatro: null,
        aceptoAviso: false,
        average: null,
        noches: null,
        // Metodo de pago
        iconoActivo: 2,
        vaucher: {
          folio: '',
          // Politicas
          tipoPolitica: false,
          politicaSeleccionada: '',
          politicaSeleccionadaCode: '',
          politicas: [{
            'nombre': 'Familiares y amigos'
          },
            {
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
          ],
          politicasLista: '',
          // Razon
          tipoRazon: false,
          razonSeleccionada: '',
          razonSeleccionadaCode: '',
          razones: [{
            'nombre': 'Grupo Posadas S.A. de C.V.'
          },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
          ],
          razonesLista: '',
        },
        credito: {
          //tarjetas
          tipoTarjeta: false,
          tarjetaSeleccionada: '',
          tarjetas: [{
            'nombre': 'American Express',
            'tipoT': 1
          },
            {
              'nombre': 'Dinners Club',
              'tipoT': 2
            },
            {
              'nombre': 'Masterd Card',
              'tipoT': 3
            },
            {
              'nombre': 'Visa',
              'tipoT': 4
            },
          ],
          tarjetasLista: '',
          tipoDeMascara: '',
          numero: '',
          nombre: '',
          expiracion: '',
          // Politicas
          tipoPolitica: false,
          politicaSeleccionada: '',
          politicas: [{
            'nombre': 'Familiares y amigos'
          },
            {
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
          ],
          politicasLista: '',
          // Razon
          tipoRazon: false,
          razonSeleccionada: '',
          razones: [{
            'nombre': 'Grupo Posadas S.A. de C.V.'
          },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
          ],
          razonesLista: '',
        },
        token: {
          //tarjetas
          tipoTarjeta: false,
          tarjetaSeleccionada: 'American Express',
          tarjetas: [{
            'nombre': 'American Express',
            'tipoT': 1
          },
            {
              'nombre': 'Dinners Club',
              'tipoT': 2
            },
            {
              'nombre': 'Masterd Card',
              'tipoT': 3
            },
            {
              'nombre': 'Visa',
              'tipoT': 4,
            }
          ],
          tarjetasLista: '',
          numero: '545454YQMEKZ5454',
          nombre: 'Pedro Zambrano Manager',
          expiracion: '08/2021',
          // Politicas
          tipoPolitica: false,
          politicaSeleccionada: 'Familiares y amigos',
          politicas: [{
            'nombre': 'Familiares y amigos'
          },
            {
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
          ],
          politicasLista: '',
          // Razon
          tipoRazon: false,
          razonSeleccionada: 'Grupo Posadas S.A. de C.V.',
          razones: [{
            'nombre': 'Grupo Posadas S.A. de C.V.'
          },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
          ],
          razonesLista: '',
        },
        tiempoLimite: {
          // Politicas
          tipoPolitica: false,
          politicaSeleccionada: '',
          politicas: [{
            'nombre': 'Familiares y amigos'
          },
            {
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
            {
              'nombre': 'Familiares y amigos'
            },
          ],
          politicasLista: '',
          // Razon
          tipoRazon: false,
          razonSeleccionada: '',
          razones: [{
            'nombre': 'Grupo Posadas S.A. de C.V.'
          },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
            {
              'nombre': 'Grupo Posadas S.A. de C.V.'
            },
          ],
          razonesLista: '',
        },
        creditoEmpresa: {
          folio: '',
          // Politicas
          tipoPolitica: false,
          politicaSeleccionada: '',
          politicaSeleccionadaCode: '',
          politicas: [],
          politicasLista: '',
          // Razon
          tipoRazon: false,
          razonSeleccionada: '',
          razonSeleccionadaCode: '',
          razones: [],
          razonesLista: '',
        },
      }
    },
 
    watch: {    
      listRequeOpcionalesSeleccionados() {
        this.totalCostWithSuppl = 0
        this.totalSupplTax = 0
        this.totalSuppAmou = 0
        if(this.listRequeOpcionalesSeleccionados.length != 0) {
          for(var i = 0; i < this.listRequeOpcionalesSeleccionados.length; i++) {
              this.totalCostWithSuppl +=  this.listRequeOpcionalesSeleccionados[i].reqOpcional.amount
              this.totalSuppAmou +=  this.listRequeOpcionalesSeleccionados[i].reqOpcional.amount
              for(var j = 0; j < this.listRequeOpcionalesSeleccionados[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
                  if( this.listRequeOpcionalesSeleccionados[i].reqOpcional.rateSupplementTaxesResponseList[j].taxCode == "IVA") {
                      this.totalSupplTax += this.listRequeOpcionalesSeleccionados[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount
                      this.totalCostWithSuppl += this.listRequeOpcionalesSeleccionados[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount
                  }
              }
          }
        }
      },
      selectAllExtra() {
        if(this.selectAllExtra) {

          if(this.$store.getters.gettingLang == 'es') {
            this.habitacion1.typePreferentExtra =  'Todas las preferencias extras'
          }
          if( this.$store.getters.gettingLang == 'en') {
            this.habitacion1.typePreferentExtra = 'All extra preferences';
          }
        }
        if(this.selectAllExtra == false && this.habitacion1.selectedExtra.length > 0 && this.$store.getters.gettingLang == 'es') {
          this.habitacion1.typePreferentExtra =     "Ver preferencias de habitación seleccionadas"
        }
        if(this.selectAllExtra == false && this.habitacion1.selectedExtra.length > 0 && this.$store.getters.gettingLang == 'en') {
          this.habitacion1.typePreferentExtra = "See selected room types"
        }
      },
      selectAll() {
        if(this.selectAll) {
          if(this.$store.getters.gettingLang == 'es') {
            this.habitacion1.typePreferent = 'Todas las preferencias de habitación'
          }
          if( this.$store.getters.gettingLang == 'en') {
            this.habitacion1.typePreferent = 'All room types'
          }
        }
      },

      fechaExpiracionTarCred(){
        this.credito.expiracion = this.fechaExpiracionTarCred;
        if (this.fechaExpiracionTarCred.length === 7) {
          var mes = this.fechaExpiracionTarCred.substring(0, 2);
          var ano = this.fechaExpiracionTarCred.substring(3, 7);
          this.validDateExpirationTarCred = GlobalFunctions.IsValidDateExpiration(mes, ano);
          this.banTarCredExp = this.validDateExpirationTarCred.banDate;
        } else {
          this.banTarCredExp = true;
        }
      },
      fechaExpiracionToken(){
        this.token.expiracion = this.fechaExpiracionToken;
        if (this.fechaExpiracionToken.length === 7) {
          var mes = this.fechaExpiracionToken.substring(0, 2);
          var ano = this.fechaExpiracionToken.substring(3, 7);
          this.validDateExpirationToken = GlobalFunctions.IsValidDateExpiration(mes, ano);
          this.banTokenExp = this.validDateExpirationToken.banDate;
        } else {
          this.banTokenExp = true;
        }
      },
      iconoActivo() {
        var updatedChangeRequest = this.ls.get("reservationRequestEdition")
        if(this.iconoActivo == 1 || this.iconoActivo == 2) {
          updatedChangeRequest.isCreditCard = 1
        } else {
          updatedChangeRequest.isCreditCard = 0
        }
        this.ls.set("reservationRequestEdition", updatedChangeRequest)
      }
    },
    computed: {
      isDisabled() {
        switch (this.iconoActivo) {
          case 0:
            if (this.vaucher.politicaSeleccionada.length > 2 && this.vaucher.razonSeleccionada.length > 2
              && this.vaucher.politicaSeleccionadaCode != '-1' && this.vaucher.razonSeleccionadaCode != '-1'
              && this.vaucher.politicaSeleccionadaCode != '' && this.vaucher.razonSeleccionadaCode != ''
              && this.aceptoAviso
              && this.banSelectedPoliticaVaucher) {
              return false;
            } else {
              return true;
            }
            break;
          case 1:
            if (this.credito.tarjetaSeleccionada.length > 2 &&
              this.credito.tipoDeMascara.length > 2 &&
              this.credito.numero.length > 9 &&
              this.credito.nombre.length > 2 &&
              this.credito.expiracion.length > 2 &&
              this.aceptoAviso
              && this.banSelectedPoliticaCredito) {
              return false;
            } else {
              return true;
            }
            break;
          case 2:
            if (this.token.tarjetaSeleccionada.length > 2 &&
              this.token.numero.length > 9 &&
              this.token.nombre.length > 2 &&
              this.token.expiracion.length > 2 &&
              this.aceptoAviso
              && this.banSelectedPoliticaToken) {
              return false;
            } else {
              return true;
            }
            break;
          case 3:
            if (this.aceptoAviso
            && this.banSelectedPoliticaTiempoLimite) {
              return false;
            } else {
              return true;
            }
            break;
          case 4:
            if ( this.creditoEmpresa.politicaSeleccionada.length > 2 && this.creditoEmpresa.razonSeleccionada.length > 2
              && this.creditoEmpresa.politicaSeleccionadaCode != '-1' && this.creditoEmpresa.razonSeleccionadaCode != '-1'
              && this.creditoEmpresa.politicaSeleccionadaCode != '' && this.creditoEmpresa.razonSeleccionadaCode != ''
              && this.aceptoAviso
              && this.banSelectedPoliticaCreditoEmpresa) {
              return false;
            } else {
              return true;
            }
            break;
          default:
            break;
        }
      },

      selectAllModal: {
        get: function () {
          return this.selected.length == this.typeRooms.length;
        },
        set: function (value) {
          var selected = [];
          if (value) {
            this.typeRooms.forEach(function (typeRoom) {
              selected.push(typeRoom.id);
            });
          }
          this.selectedModal = selected;
        }
      },
      // Tipo de preferencia
      selectAll: {
        get: function () {
          return this.habitacion1.typeRoomsPreferents ? this.habitacion1.selected.length == this
            .habitacion1.typeRoomsPreferents.length : false;
        },
        set: function (value) {
          var selected = [];
          if (value) {
            this.habitacion1.typeRoomsPreferents.forEach(function (typeRoomPreferent) {
              selected.push(typeRoomPreferent.id);
            });
          }
          this.habitacion1.selected = selected;
        }
      },
      // Tipo de preferencia extra
      selectAllExtra: {
        get: function () {
          return this.habitacion1.typeExtrasPreferents ? this.habitacion1.selectedExtra.length ==
            this.habitacion1.typeExtrasPreferents.length : false;
        },
        set: function (value) {
          var selectedExtra = [];
          if (value) {
            this.habitacion1.typeExtrasPreferents.forEach(function (typeExtraPreferent) {
              selectedExtra.push(typeExtraPreferent.id);
            });
          }
          this.habitacion1.selectedExtra = selectedExtra;
        }
      },

      isDisabledTokenizador() {
        switch (this.iconoActivo) {
          case 1: // Tarjeta de crédito
            if (this.credito.tarjetaSeleccionada.length > 2) {
              return false;
            } else {
              this.credito.numero == ''
              return true;
            }
            break;
          case 2: // Token
            if (this.token.tarjetaSeleccionada.length > 2) {
              return false;
            } else {
              return true;
            }
            break;
          default:
            return true;
            break;
        }
      },
      y() {
        if(this.$store.getters.gettingLang == "es") {
          return "y"
        } else {
          return "and"
        }
      },
      isDisabledCheckbox(){
        this.aceptoAviso = false;
        if (this.iconoActivo === 0 || this.iconoActivo === 3 || this.iconoActivo === 4) {
          return false;
        } else{
          if (((this.iconoActivo === 1 && (this.credito.numero !== '' && this.credito.expiracion !== '' && this.credito.nombre !== '' && this.credito.tarjetaSeleccionada !== ''))
            || (this.iconoActivo === 2 && (this.token.numero !== '' && this.token.expiracion !== '' && this.token.nombre !== '' && this.token.tarjetaSeleccionada !== '')))) {
            return false;
          } else{
            return true;
          }
        }
      },

    },
    created() {
      this.isUserGeneric = this.ls.get('isUserGeneric').data;
var manSuppF = this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses
   this.tabActiveFR = this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.rateType
   this.average = this.ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.totalRateWithoutTaxes 
   this.noches = this.ls.get('updateCostDetail').data.hotel.nights
   
this.descriptionMS = ""
var obSupp = [] 
for(var i = 0; i < manSuppF.length; i++) {
  if(manSuppF[i].rateMandatorySupplementResponseList != null) {
    for(var j = 0; j < manSuppF[i].rateMandatorySupplementResponseList.length; j++) {
      // Get all supplemets
      obSupp.push({ quantity: manSuppF[i].rateMandatorySupplementResponseList[j].numSuppleCharged, name: manSuppF[i].rateMandatorySupplementResponseList[j].supplementName})
  
   }   
  } 
}
var obSupp2 = obSupp
let uniqueSupp = obSupp.map(item => item.name)
  .filter((value, index, self) => self.indexOf(value) === index)
    var counter = {}
    obSupp2.forEach(function(obj) {
    var key = JSON.stringify(obj)
    counter[key] = (counter[key] || 0) + 1
    })
for(var i = 0; i < Object.keys(counter).length; i++) {
            var letJson = JSON.parse(Object.entries(counter)[i][0])
            var timesS = Object.entries(counter)[i][1]
           this.descriptionMS += letJson.quantity * timesS 
           this.descriptionMS += " "
           this.descriptionMS += letJson.name
           this.descriptionMS += ", "
}
// Print mandatory texts

           this.descriptionMS = this.descriptionMS.trim()
           this.descriptionMS = this.descriptionMS.slice(0, -1); 
this.ls.set("descriptionMS", this.descriptionMS)
        
        // Optional supplements 
        var optioS = this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.rateOptionalSupplementResponseList
        if(optioS != null && optioS.length != 0) {
          this.suplementosOpcionales(optioS);
        }


      // Set de dat
      if(this.ls.get('dernierDM') != null) {
        let upDate = this.ls.get('updateCostDetail')
       upDate.data.habitacion.beautiDateOutput = this.ls.get('dernierDM')
       this.ls.set('updateCostDetail', upDate)

        }
     
      // Set der data
      this.ls.set('supplDeta', false)

      this.hotelReservationByCode = this.ls.get('hotelReservationByCodeModd');
      this.dataTokenExist = this.ls.get('hotelDetailModd');
      if(this.ls.get('Language').data == "en") {
        this.habitacion1.typePreferentExtra =  'See selected extra preferences';
        this.habitacion1.typePreferent =  'See selected room types';
        this.allRoomTypesT = "All room types"
        this.extraPreferencesT = "All extra preferences"

      }

      if (this.hotelReservationByCode.hotelDetailResponse.specialMessage.length > 0) {
        this.banConsiEspe = true;
        this.considEspe = this.hotelReservationByCode.hotelDetailResponse.specialMessage[0];
      }
      this.email = this.ls.get('emailManquant')
// Add preferences texts to template
      this.preTe = this.ls.get('preTe')
// Change to rates in change request
      var aT = this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].rateMandatorySupplementResponseList.quantity
      if(aT== null) {
        var totalQuantity22 = ''
      } else {

        if(aT.length == 0) {
          var totalQuantity22 = ""
        } else {

          var totalQuantity22 = aT
        }
      }
      this.currencyCode = this.ls.get('datosHabHotSelected').data.habitacion.currencyCode
      var newPrice = this.ls.get('datosHabHotSelected').data.hotel.price
      this.ls.set("totalStayRO", newPrice)
      var updatedChangeRequest = this.ls.get("reservationRequestEdition")
      updatedChangeRequest.datos.nights = this.ls.get('datosHabHotSelected').data.hotel.nights
      var ni = this.ls.get('datosHabHotSelected').data.hotel.nights
      this.ls.set("nightsReadOnly", ni)
      var isN = this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.rateType
      this.ls.set("typeNameRO", isN)
      var aD = this.ls.get("reservationRequestEdition").datos.checkInDate
      var dD = this.ls.get("reservationRequestEdition").datos.checkOutDate
      this.requirementsByCode = this.ls.get("reservationRequestEdition").profile[0].preferencias
      this.ls.set("arrivalDateReadOnly", aD)
      this.ls.set("departureDateReadOnly", dD)
      updatedChangeRequest.datos.contractCode = this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.contractCode
      updatedChangeRequest.datos.contractType = this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.contractType
      updatedChangeRequest.rates.totalCostWithoutTaxes = this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.totalRateWithoutTaxes
      updatedChangeRequest.rates.totalTaxes = this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.totalTaxes
      updatedChangeRequest.rates.totalCostWithTaxes = this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.totalRateWithTaxes
      updatedChangeRequest.rates.totalSupplements = this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.totalSupplement
      updatedChangeRequest.rates.totalCost = this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.totalRateWithTaxes
      updatedChangeRequest.rates.averageCostPerNight = this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.averageRatePerNight
      updatedChangeRequest.rates.quantity = totalQuantity22
      updatedChangeRequest.rates.ratesDetailResponseList = this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses
      updatedChangeRequest.datos.yieldType = this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.yieldType
      updatedChangeRequest.hotel.roomCode = this.ls.get('datosHabHotSelected').data.hotel.roomCode
      updatedChangeRequest.hotel.roomImage =this.ls.get('datosHabHotSelected').data.hotel.img
      updatedChangeRequest.hotel.roomName =this.ls.get('datosHabHotSelected').data.hotel.title
      var rN = this.ls.get('datosHabHotSelected').data.hotel.title
      this.ls.set("roomNameRO", rN)
      if(this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].commissionResponse == null) {

        updatedChangeRequest.rates.ratesDetailResponseList[0].commissionResponse = null
      }
      this.ls.set("reservationRequestEdition", updatedChangeRequest)

      var responseSup = {
        supplementMandatoryResponseList: this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].rateMandatorySupplementResponseList,
        supplementNotMandatoryResponseList: []
      }
      this.ls.set('supplement', {data:responseSup});
      let politicas                  = this.ls.get("HotelDetailDataPoliticas").data.response;
         let  datosHabHotSelected = this.ls.get("datosHabHotSelected");

      this.HotelDetailDataPoliticas  = politicas.ratePolicyElementResponseList;
       this.datosHabHotSelected = datosHabHotSelected.data;
      this.consultaMetodosPago()
      this.defaultPayment()
      this.politicaViajeRazonSocial()
      this.totalCost = this.ls.get("totalStayRO")
      this.noConfir = this.ls.get("noConForRm")
      this.hotelMainImage = this.ls.get("datosHabHotSelected").data.hotel.img
      if(this.hotelMainImage == "Contenido no disponible" || this.hotelMainImage == "Content not available") {
        this.altImg = this.hotelMainImage
      } else {
        this.altImg = ""
      }
      this.hotelName = this.ls.get("hotelNameReadOnly")
      this.roomName = this.ls.get("roomNameRO")
      this.name = this.ls.get("nameReadOnly").fullName
      this.company = this.ls.get("companionReadOnly").fullName
      if(this.company == "" || this.company == null) {
        this.company = "----"
      }


      this.arrivalDate = this.ls.get("arrivalDateReadOnly")
      this.departureDate = this.ls.get("departureDateReadOnly")
      this.reA  =        this.ls.get("arrivalForm")
      this.reD =     this.ls.get("departureForm")

      this.nights = this.ls.get("nightsReadOnly")
      this.rooms = this.ls.get("totalRoomsReadOnly")
      this.isNegotiated = this.ls.get("typeNameRO")
      this.adults = this.ls.get("totalGuestsReadOnly").data.totalAdults
      this.minors = this.ls.get("totalGuestsReadOnly").data.totalChildren
      this.infants = this.ls.get("totalGuestsReadOnly").data.totalInfants
      this.guests = this.minors + this.infants + this.adults
    },
    methods: {
         handlePaste(event ) {
          console.log("FROM Mod Lectura vue");
       const lang=this.ls.get('Language').data;
       console.log("value for this.language"+lang);
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (pastedText.includes('|')) {           
        event.preventDefault();
         if(lang == 'es'){
           alert('El carácter "|" no está permitido al pegar texto.');           
        }else{
           alert('The "|" character is not allowed when pasting text');
        }
          
      }
     
  },
      error6Modal(){
        this.banError6 = false;
        this.$router.push({ name: 'Reservaciones'});
      },
      filteredPolilticas() {
        switch (this.iconoActivo) {
          case 0:
            //vaucher
           
            return this.vaucher.politicasLista = this.politicasList.filter(pol => {
              return pol.nombre.toLowerCase().includes(this.vaucher.politicaSeleccionada.toLowerCase())
            });
            break;
          case 1:
            //credito
          
            return this.credito.politicasLista = this.politicasList.filter(pol => {
              return pol.nombre.toLowerCase().includes(this.credito.politicaSeleccionada.toLowerCase())
            });
            break;
          case 2:
            //token
            
            return this.token.politicasLista = this.politicasList.filter(pol => {
              return pol.nombre.toLowerCase().includes(this.token.politicaSeleccionada.toLowerCase())
            });
            break;
          case 3:
            //tiempo limite
           
            return this.tiempoLimite.politicasLista = this.politicasList.filter(pol => {
              return pol.nombre.toLowerCase().includes(this.tiempoLimite.politicaSeleccionada.toLowerCase())
            });
            break;
          case 4:
            //credito empresa
           
            return this.creditoEmpresa.politicasLista = this.politicasList.filter(pol => {
              return pol.nombre.toLowerCase().includes(this.creditoEmpresa.politicaSeleccionada.toLowerCase())
            });
            break;
        }
      },
      redirecAvisoPrivacidad(){
        (this.ls.get('Language').data=='es'?window.open(process.env.VUE_APP_POLICIES, '_blank'):window.open(process.env.VUE_APP_POLICIESEN, '_blank'));
      },
      closeModalNew(){
        this.banNewModal = false;
        setTimeout(() => {
          this.$router.push({ name: 'Reservaciones'});
        }, 100);
      },
       clicCheckBoxReqOpcional(e, reqOpcional, index){
        if(e.target.checked == false) {
          for (let i = 0; i < this.listRequeOpcionalesSeleccionados.length; i++) {
            if (this.listRequeOpcionalesSeleccionados[i].index === index) {
              this.listRequeOpcionalesSeleccionados.splice(i, 1);
            }
          }
        } else {
          this.listRequeOpcionalesSeleccionados.push({index: index, reqOpcional});
        }
        var opSuE = []
        for(var i=0; i < this.listRequeOpcionalesSeleccionados.length; i++) {
            opSuE.push(this.listRequeOpcionalesSeleccionados[i].reqOpcional)
        }
        this.$store.commit('listRequeOpcionalesSeleccionadosForConfir',  this.listRequeOpcionalesSeleccionados)
        this.ls.set('opSuE', opSuE)
      },
         suplementosOpcionales(listRequeOpcionales){
        if (listRequeOpcionales.length === 0) {
          this.banReqOpcionales = false;
        } else {
          this.listRequeOpcionales = listRequeOpcionales;
          this.banReqOpcionales = true;
        }
      },
      modalToken(lugar){
        if (!this.isUserGeneric && this.dataTokenExist != null) {
          if (this.hotelReservationByCode.paymentResponse.creditCard != null &&this.hotelReservationByCode.paymentResponse.creditCard.cardNumber === this.dataTokenExist.guaranteeNumber || this.dataTokenExist.guaranteeNumber === '') {
            this.banIsTokenGuardado = true;
          } else {
            this.banIsTokenGuardado = false;
          }
          /** lugar
           * 1: tarjeta credito
           * 2: token
           */
          this.modalTokenCredito.lugar = lugar;
          if ((this.dataTokenExist != null && this.dataTokenExist != '' && this.dataTokenExist != undefined && this.dataTokenExist.guaranteeNumber !== '') && (this.iconoActivo === 1 || this.iconoActivo === 2)) {
            if (this.mostrarTipoTarjetaAutocompleteToken(this.dataTokenExist.guaranteeType) === undefined) {
              this.banModalTokenInexistente = true;
              this.banTokenInexistente = true;
            } else {
              if (lugar === 1 || lugar === 3) {
                this.modalTokenCredito.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.tarjetaGuardado');
                this.modalTokenCredito.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text2') + ' ' + this.dataTokenExist.guaranteeNumber.substring(0, this.dataTokenExist.guaranteeNumber.length - 4).replace(/./g,"*") + ' ' + this.dataTokenExist.guaranteeNumber.substring(this.dataTokenExist.guaranteeNumber.length - 4) + '?';
                this.modalTokenCredito.modalNumberToken = this.dataTokenExist.guaranteeNumber;
              }
              if (lugar === 2 || lugar === 4) {
                this.modalTokenCredito.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.tokenGuardado');
                this.modalTokenCredito.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text1') + ' ' + this.dataTokenExist.guaranteeNumber.substring(0, this.dataTokenExist.guaranteeNumber.length - 4).replace(/./g,"*") + ' ' + this.dataTokenExist.guaranteeNumber.substring(this.dataTokenExist.guaranteeNumber.length - 4) + '?';
                this.modalTokenCredito.modalNumberToken = this.dataTokenExist.guaranteeNumber;
              }
              if (lugar === 1 || lugar === 2) {
                this.banIsTokenGuardado = true;
                this.isModalVisibleUsarToken = true;
              }
            }
          }
        }
      },
      modalSaveUpdate(lugar){
        if (lugar === 1) {
          if ((this.modalTokenCredito.lugar === 1 || this.modalTokenCredito.lugar === 2 || this.modalTokenCredito.lugar === 3 || this.modalTokenCredito.lugar === 4) && this.dataTokenExist.guaranteeNumber !== '') {
            this.saveOrUpdate = 'UPDATE';
          }
          if ((this.modalTokenCredito.lugar === 1 || this.modalTokenCredito.lugar === 2 || this.modalTokenCredito.lugar === 3 || this.modalTokenCredito.lugar === 4) && this.dataTokenExist.guaranteeNumber === '') {
            this.saveOrUpdate = 'SAVE';
          }
        }
        if (lugar === 2) {
          this.saveOrUpdate = '';
        }

        this.closeModal();
      },
      mostrarTipoTarjetaAutocompleteToken(buscar){
        if (this.modalTokenCredito.lugar === 1 || this.modalTokenCredito.lugar === 3) {
          return this.credito.tarjetas.find( lista => lista.code === buscar );
        }
        if (this.modalTokenCredito.lugar === 2 || this.modalTokenCredito.lugar === 4) {
          return this.token.tarjetas.find( lista => lista.code === buscar );
        }

      },
      closeModalToken() {
        this.isModalVisibleUsarToken = false;
      },
      closeModal() {
        this.isModalVisible = false;
      },
      modalTokenCreditYes(){
        if (this.modalTokenCredito.lugar === 1 || this.modalTokenCredito.lugar === 3) {
          //tarjeta de credito
          this.credito.tarjetaSeleccionada = this.mostrarTipoTarjetaAutocompleteToken(this.dataTokenExist.guaranteeType).nombre; //guaranteeType
          this.cardTypeForService = this.dataTokenExist.guaranteeType;
          this.credito.tipoDeMascara = this.dataTokenExist.guaranteeNumber;
          this.credito.numero = this.dataTokenExist.guaranteeNumber;
          this.credito.nombre = this.dataTokenExist.holderName;
          this.credito.expiracion = this.dataTokenExist.expirationDate.replace('/','');
          this.fechaExpiracionTarCred = this.dataTokenExist.expirationDate.replace('/','');
        }
        if (this.modalTokenCredito.lugar === 2 || this.modalTokenCredito.lugar === 4) {
          //token
          this.token.tarjetaSeleccionada = this.mostrarTipoTarjetaAutocompleteToken(this.dataTokenExist.guaranteeType).nombre; //guaranteeType
          this.tokenCreditCardType = this.dataTokenExist.guaranteeType;
          this.token.numero = this.dataTokenExist.guaranteeNumber;
          this.token.nombre = this.dataTokenExist.holderName;
          this.token.expiracion = this.dataTokenExist.expirationDate.replace('/','');
          this.fechaExpiracionToken = this.dataTokenExist.expirationDate.replace('/','');
        }
        this.closeModalToken();
      },
      modalCheckbox(){
        if (!this.isUserGeneric) {
          var ban = false;
          if (this.hotelReservationByCode.guestID === '' || this.hotelReservationByCode.guestID === null || this.hotelReservationByCode.guestID === 0) {
            ban = false;
          } else {
            ban = true;
          }
          var tipoTar = '';
          for (let i = 0; i < this.credito.tarjetas.length; i++) {
            if (this.credito.tarjetas[i].code === this.dataTokenExist.guaranteeType) {
              tipoTar = this.credito.tarjetas[i].nombre
            }
          }
  
          var tipoTok = '';
          for (let ii = 0; ii < this.token.tarjetas.length; ii++) {
            if (this.token.tarjetas[ii].code === this.dataTokenExist.guaranteeType) {
              tipoTok = this.token.tarjetas[ii].nombre
            }
          }
  
          if (!this.getBrowserForCheckbox(this.aceptoAviso) && (this.iconoActivo === 1 || this.iconoActivo === 2)
            && ((this.iconoActivo === 1 && (this.dataTokenExist.guaranteeNumber !== this.credito.numero || this.dataTokenExist.expirationDate !== this.credito.expiracion ||  this.dataTokenExist.holderName.toUpperCase() !== this.credito.nombre.toUpperCase() || tipoTar !== this.credito.tarjetaSeleccionada))
              || (this.iconoActivo === 2 && (this.dataTokenExist.guaranteeNumber !== this.token.numero || this.dataTokenExist.expirationDate !== this.token.expiracion ||  this.dataTokenExist.holderName.toUpperCase() !== this.token.nombre.toUpperCase() || tipoTok !== this.token.tarjetaSeleccionada)))
            && !(!ban && this.dataTokenExist.guaranteeNumber == '') && !this.banTokenInexistente && this.banIsTokenGuardado ) {
  
            if ((this.modalTokenCredito.lugar === 1 || this.modalTokenCredito.lugar === 3) && this.dataTokenExist.guaranteeNumber !== '') {
              this.modalTokenCreditoSaveUpdate.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.actualizarTarjetaCredito');
              this.modalTokenCreditoSaveUpdate.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text4');
            }
            if ((this.modalTokenCredito.lugar === 1 || this.modalTokenCredito.lugar === 3) && this.dataTokenExist.guaranteeNumber === '') {
              this.modalTokenCreditoSaveUpdate.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.guardadoTarjeta');
              this.modalTokenCreditoSaveUpdate.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text3');
            }
  
            if ((this.modalTokenCredito.lugar === 2 || this.modalTokenCredito.lugar === 4) && this.dataTokenExist.guaranteeNumber !== '') {
              this.modalTokenCreditoSaveUpdate.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.actualizarToken');
              this.modalTokenCreditoSaveUpdate.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text6');
            }
            if ((this.modalTokenCredito.lugar === 2 || this.modalTokenCredito.lugar === 4) && this.dataTokenExist.guaranteeNumber === '') {
              this.modalTokenCreditoSaveUpdate.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.guardadoToken');
              this.modalTokenCreditoSaveUpdate.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text5');
            }
  
            this.isModalVisible = true;
          }
        }
      },
      getBrowserForCheckbox(boleano){
        var navegador = GlobalFunctions.getBrowserInfo().toLowerCase();
        if (navegador.search('ie') > -1 || navegador.search('edge') > -1) {
          return !boleano;
        } else {
          return boleano;
        }

      },
      seeRoomsP() {
        this.mergeUpdate = true
        if(this.selectAll && this.$store.getters.gettingLang == 'es') {
          this.habitacion1.typePreferent = 'Todas las preferencias de habitación'
        }
        if(this.selectAll && this.$store.getters.gettingLang == 'en') {
          this.habitacion1.typePreferent = 'All room types'
        }
        this.totalPreferencesRoomsWS = []
        for(var i = 0; i < this.habitacion1.selected.length; i++) {
          for(var ii = 0; ii < this.habitacion1.typeRoomsPreferents.length; ii++) {
            if(this.habitacion1.selected[i] == this.habitacion1.typeRoomsPreferents[ii].id) {
              this.totalPreferencesRoomsWS.push(this.habitacion1.typeRoomsPreferents[ii].code)
            }
          }
        }
        var a =    this.totalPreferencesRoomsWS.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
        this.totalPreferencesRoomsWS = a
      },
      seeRoomsE() {
        this.mergeUpdate = true
        if(this.selectAllExtra && this.$store.getters.gettingLang == 'es') {
          this.habitacion1.typePreferentExtra =  'Todas las preferencias extras'
        }
        if(this.selectAll && this.$store.getters.gettingLang == 'en') {
          this.habitacion1.typePreferentExtra = 'All extra preferences';
        }
        this.totalPreferencesEWS = []
        for(var i = 0; i < this.habitacion1.selectedExtra.length; i++) {
          for(var ii = 0; ii < this.habitacion1.typeExtrasPreferents.length; ii++) {
            if(this.habitacion1.selectedExtra[i] == this.habitacion1.typeExtrasPreferents[ii].id) {
              this.totalPreferencesEWS.push(this.habitacion1.typeExtrasPreferents[ii].code)
            }
          }
        }
        var b =    this.totalPreferencesEWS.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
        this.totalPreferencesEWS = b
      },
      seeFloor(code, name) {
        this.seeTextFloor = name
        if(this.totalPreferences.includes(this.arrayFloors[0].requirementCode || this.arrayFloors[1].requirementCode)) {

          for(var i = 0; i <this.totalPreferences.length; i++) {
            if(this.totalPreferences[i] ==this.arrayFloors[0].requirementCode || this.totalPreferences[i] ==this.arrayFloors[1].requirementCode) {
              delete this.totalPreferences[i];
            }
          }
          this.totalPreferences.push(code)
          var a =    this.totalPreferences.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
          this.totalPreferences = a
        } else {

          for(var i = 0; i <this.totalPreferences.length; i++) {
            if(this.totalPreferences[i] ==this.arrayFloors[0].requirementCode || this.totalPreferences[i] ==this.arrayFloors[1].requirementCode) {
              delete this.totalPreferences[i];
            }
          }
          this.totalPreferences.push(code)
          var a =    this.totalPreferences.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
          this.totalPreferences = a
        }

        var a =    this.totalPreferences.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
        this.totalPreferences = a
      },
      seeSmoke(code, name) {
        this.seeTextSmoke= name
        if(this.totalPreferences.includes(this.arraySmoke[0].requirementCode || this.arraySmoke[1].requirementCode)) {
          for(var i = 0; i <this.totalPreferences.length; i++) {
            if(this.totalPreferences[i] ==this.arraySmoke[0].requirementCode || this.totalPreferences[i] ==this.arraySmoke[1].requirementCode) {

              delete this.totalPreferences[i];
            }
          }
          this.totalPreferences.push(code)
          var a =    this.totalPreferences.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
          this.totalPreferences = a
        } else {

          for(var i = 0; i <this.totalPreferences.length; i++) {
            if(this.totalPreferences[i] ==this.arraySmoke[0].requirementCode || this.totalPreferences[i] ==this.arraySmoke[1].requirementCode) {

              delete this.totalPreferences[i];
            }
          }


          this.totalPreferences.push(code)
          var a =    this.totalPreferences.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
          this.totalPreferences = a
        }


        var a =    this.totalPreferences.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
        this.totalPreferences = a
      },
      // tipos de preferencia extra
      handleTypeExtra(e) {
        if (e.target.checked == false) {
          this.habitacion1.typePreferentExtra = '';
        } else if(this.$store.getters.gettingLang == "es") {
          this.extraPreferencesT = "Todas las preferencias extras"
          this.habitacion1.typePreferentExtra = 'Todas las preferencias extras';
        } else {
          this.extraPreferencesT = "All extra preferences"
          this.habitacion1.typePreferentExtra = 'All extra preferences';
        }
      },

      handleTypeSelectExtra(e, type) {
        if (e.target.checked == false) {
          if(this.habitacion1.selectedExtra.length == 1) {
            for(var ii = 0; ii < this.habitacion1.typeExtrasPreferents.length; ii++) {
              if(this.habitacion1.selectedExtra[0] == this.habitacion1.typeExtrasPreferents[ii].id) {
                return     this.habitacion1.typePreferentExtra =     this.habitacion1.typeExtrasPreferents[ii].name
              }
            }

          }
          if(this.habitacion1.selectedExtra.length == 0) {
            return     this.habitacion1.typePreferentExtra = ''
          }
          if(this.habitacion1.selectedExtra.length > 1 && this.$store.getters.gettingLang == 'es') {

            return this.habitacion1.typePreferentExtra = 'Ver preferencias extras seleccionadas';
          } else
          {
            return this.habitacion1.typePreferentExtra = ''

          }

          if(this.habitacion1.selectedExtra > 1 && this.$store.getters.gettingLang == 'en') {

            return this.habitacion1.typePreferentExtra = 'See selected extra preferences';
          }  else
          {
            return this.habitacion1.typePreferentExtra = ''

          }
        } else {
          if (this.habitacion1.selectedExtra.length > 1) {
            if(this.$store.getters.gettingLang == 'es') {

              this.habitacion1.typePreferentExtra =  'Ver preferencias extras seleccionadas';
            } else {
              this.habitacion1.typePreferentExtra =  'See selected extra preferences';


            }
          } else {
            this.habitacion1.typePreferentExtra = type;
          }
        }
      },
      outsidePreferentsExtra(e) {
        this.seeRoomsE()
        this.habitacion1.extraPreferences = true;
      },
      // tipos de habitacions
      handleType(e) {
        if (e.target.checked == false) {
          return this.habitacion1.typePreferent = '';
        } else if(this.$store.getters.gettingLang == "es") {
          this.allRoomTypesT = "Todas las preferencias de habitación"
          return this.habitacion1.typePreferent = 'Todas las preferencias de habitación';
        } else {
          this.allRoomTypesT = "All room types"

          return this.habitacion1.typePreferent = 'All room types';

        }
      },
      handleTypeSelect(e, type) {
        if (e.target.checked == false) {

          if(this.habitacion1.selected.length == 1) {
            for(var ii = 0; ii < this.habitacion1.typeRoomsPreferents.length; ii++) {
              if(this.habitacion1.selected[0] == this.habitacion1.typeRoomsPreferents[ii].id) {
                return     this.habitacion1.typePreferent =     this.habitacion1.typeRoomsPreferents[ii].name
              }
            }

          }
          if(this.habitacion1.selected.length == 0) {
            return     this.habitacion1.typePreferent = ''
          }
          if(this.habitacion1.selected.length > 1 && this.$store.getters.gettingLang == 'es') {

            return this.habitacion1.typePreferent = 'Ver preferencias de habitación seleccionadas';
          }

          if(this.habitacion1.selected > 1 && this.$store.getters.gettingLang == 'en') {

            return this.habitacion1.typePreferent = 'See selected room types';
          }
        } else {
          if (this.habitacion1.selected.length > 1) {

            if(this.$store.getters.gettingLang == 'es') {

              this.habitacion1.typePreferent =  'Ver preferencias de habitación seleccionadas';
            } else {
              this.habitacion1.typePreferent =  'See selected room types';

            }
          } else {
            this.habitacion1.typePreferent = type;
          }
        }
      },
      handleTypeModal(e) {
        if (e.target.checked == false) {
          return this.tipoHabitacion = '';
        } else {
          if(this.$store.getters.gettingLang == 'es') {
            return this.tipoHabitacion = 'Todas las preferencias de habitación';
          } else {
            return this.tipoHabitacion = 'All room types';
          }
        }
      },
      tryingAgain() {
        if(  this.selected.length != this.typeRooms.length &&  this.selected.length > 1 && this.$store.getters.gettingLang == 'es' ) {
          this.tipoHabitacion =  'Ver preferencias de habitación seleccionadas';

        }
        if(  this.selected.length != this.typeRooms.length &&  this.selected.length > 1 && this.$store.getters.gettingLang == 'en' ) {
          this.tipoHabitacion =  'See selected room types';

        }

        if(  this.selected.length == this.typeRooms.length  && this.$store.getters.gettingLang == 'es' ) {
          this.tipoHabitacion =  'Todas las preferencias de habitación';

        }
        if(  this.selected.length == this.typeRooms.length &&   this.$store.getters.gettingLang == 'en' ) {
          this.tipoHabitacion =  'All room types';

        }
        if(  this.selected.length == 0  && this.$store.getters.gettingLang == 'es' ) {
          this.tipoHabitacion =  'Seleccionar';

        }
        if(  this.selected.length == 0 &&   this.$store.getters.gettingLang == 'en' ) {
          this.tipoHabitacion =  'Select';

        }


      },
      outsideRoomPreferents(e) {
        this.seeRoomsP()
        this.habitacion1.roomPreferences = true;
      },
      getRequirements() {
        GlobalServices._consultaRequerimientos(this.ls.get("hotelCodeROWS"), this.ls.get('Token').data, this.ls.get('Language').data).then(responseReq => {
          if (responseReq.status === 200) {
            this.requeriment(responseReq.data);
          }
        }).catch(error => {

                              // Error server
 if( (error.status == 404 && (error.errorCode == "RSP_LIFERAY_PARSE_01" || error.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.status == 500 || error.status == 502 || error.status == 503 || error.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
        });
      },
      requeriment(dataReq){

        var totalCodeRooms = []
        var totalTextRooms = []
        var totalCodeExtras = []
        var totalTextExtras = []
        var smokeText = ""
        var floorText = ""

        var lisTem = {
          habitacion: null,
          extras: null,
          piso: null,
          fumar: null
        };
        var listTemp2 = [];
        for (var dat of dataReq) {
          listTemp2 = [];
          for (let i = 0; i < dat.requirementResponseList.length; i++) {
            var tem = {id: i+1, name: dat.requirementResponseList[i].requirementName, code: dat.requirementResponseList[i].requirementCode};
            listTemp2.push(tem);
          }
          if (dat.requirementType.toLowerCase().search('habitación') > -1 || dat.requirementType.toLowerCase().search('room') > -1) {
            if(dat == null) {
              dat = ""
            }
            lisTem.habitacion = dat;
            this.habitacion1.selected = []

            this.habitacion1.typeRoomsPreferents = listTemp2;

            for(var i = 0; i < this.requirementsByCode.length; i++) {
              for(var ii = 0; ii < this.habitacion1.typeRoomsPreferents.length; ii++) {
                if(this.requirementsByCode[i] == this.habitacion1.typeRoomsPreferents[ii].code) {
                  this.habitacion1.selected.push(this.habitacion1.typeRoomsPreferents[ii].id)
                }
              }
            }
            for(var i = 0; i < this.habitacion1.selected.length; i++) {
              for(var ii = 0; ii < this.habitacion1.typeRoomsPreferents.length; ii++) {
                if(this.habitacion1.typeRoomsPreferents[ii].id == this.habitacion1.selected[i]) {
                  totalCodeRooms.push(this.habitacion1.typeRoomsPreferents[ii].code)
                  totalTextRooms.push(this.habitacion1.typeRoomsPreferents[ii].name)

                }
              }
            }
          }
          if (dat.requirementType.toLowerCase().search('extras') > -1) {
            if(dat == null) {
              dat = ""
            }
            lisTem.extras = dat;
            this.habitacion1.typeExtrasPreferents = listTemp2;
            this.habitacion1.selectedExtra = []
            for(var i = 0; i < this.requirementsByCode.length; i++) {
              for(var ii = 0; ii < this.habitacion1.typeExtrasPreferents.length; ii++) {
                if(this.requirementsByCode[i] == this.habitacion1.typeExtrasPreferents[ii].code) {
                  this.habitacion1.selectedExtra.push(this.habitacion1.typeExtrasPreferents[ii].id)
                }
              }
            }


            for(var i = 0; i < this.habitacion1.selectedExtra.length; i++) {
              for(var ii = 0; ii < this.habitacion1.typeExtrasPreferents.length; ii++) {
                if(this.habitacion1.typeExtrasPreferents[ii].id == this.habitacion1.selectedExtra[i]) {
                  totalCodeExtras.push(this.habitacion1.typeExtrasPreferents[ii].code)
                  totalTextExtras.push(this.habitacion1.typeExtrasPreferents[ii].name)
                }
              }
            }
          }
          if (dat.requirementType.toLowerCase().search('piso') > -1 || dat.requirementType.toLowerCase().search('floor') > -1) {
            if(dat == null) {
              dat = ""
            }
            lisTem.piso = dat;
            this.arrayFloors = dat.requirementResponseList;
            for(var i = 0; i < this.requirementsByCode.length; i++) {
              for(var ii = 0; ii < dat.requirementResponseList.length; ii++) {
                if(this.requirementsByCode[i] == dat.requirementResponseList[ii].requirementCode) {
                  this.habitacion1.pickedPiso = this.requirementsByCode[i]
                  floorText = dat.requirementResponseList[ii].requirementName
                  this.seeTextFloor = floorText
                }
              }
            }

          }
          if (dat.requirementType.toLowerCase().search('fumar') > -1 || dat.requirementType.toLowerCase().search('smoking') > -1) {
            if(dat == null) {
              dat = ""
            }
            lisTem.fumar = dat;
            this.arraySmoke = dat.requirementResponseList;
            for(var i = 0; i < this.requirementsByCode.length; i++) {
              for(var ii = 0; ii < dat.requirementResponseList.length; ii++) {
                if(this.requirementsByCode[i] == dat.requirementResponseList[ii].requirementCode) {
                  this.habitacion1.pickedFumar = this.requirementsByCode[i]
                  smokeText = dat.requirementResponseList[ii].requirementName
                  this.seeTextSmoke = smokeText

                }
              }
            }
          }
        }
        this.listRequeriment = lisTem;
        this.rRe = true
        // Getting total code preferences
        this.totalPreferences =   totalCodeRooms.concat(totalCodeExtras)
        if(this.habitacion1.pickedPiso != null && this.habitacion1.pickedPiso != "") {

          this.totalPreferences.push(this.habitacion1.pickedPiso)
        }
        if(this.habitacion1.pickedFumar != null && this.habitacion1.pickedFumar != "") {

          this.totalPreferences.push(this.habitacion1.pickedFumar)
        }
        this.totalPrefTexto =  totalTextExtras.concat(totalTextRooms)
        if(floorText != null && floorText != "") {

          this.totalPrefTexto.push(floorText)
        }
        if(smokeText != null && smokeText != "") {
          this.totalPrefTexto.push(smokeText)

        }
        this.textPref  =   this.totalPrefTexto.join(", ");
      },
      sendVoucher() {
        this.isVoucherPayment = true

        this.isCreditCardPayment = false

        this.isTokenPayment = false

        this.isTimeLimitPayment = false

        this.isCreditPayment = false
      },
      sendCreditCard() {
        this.isVoucherPayment = false

        this.isCreditCardPayment = true

        this.isTokenPayment = false

        this.isTimeLimitPayment = false

        this.isCreditPayment = false
      },
      sendToken() {
        this.isVoucherPayment = false

        this.isCreditCardPayment = false

        this.isTokenPayment = true

        this.isTimeLimitPayment = false

        this.isCreditPayment = false
      },
      sendTimeLimit() {
        this.isVoucherPayment = true

        this.isCreditCardPayment = false

        this.isTokenPayment = false

        this.isTimeLimitPayment = true

        this.isCreditPayment = false
      },
      sendCreditPay() {
        this.isVoucherPayment = true

        this.isCreditCardPayment = false

        this.isTokenPayment = false

        this.isTimeLimitPayment = false

        this.isCreditPayment = true
      },
      changeResCon() {
        this.changeLoader = true

        var a = '';
        a = this.ls.get('Token');
        var token = a.data.substr(1);
        var language = this.ls.get('Language');
        var reservationRequest = this.ls.get('reservationRequestEdition');
        if(this.iconoActivo == 1 ) {
          var str = this.credito.expiracion;
          var month = this.credito.expiracion.substring(0, 2);
          var year = this.credito.expiracion.substring(2);
          var payCode = ""
          for(var i = 0; i < this.credito.tarjetas.length; i++) {
            if(this.credito.tarjetas[i].nombre == this.credito.tarjetaSeleccionada) {
              payCode = this.credito.tarjetas[i].code
            }
          }

          var holName = '';
          if (this.iconoActivo === 1) {
            holName = this.credito.nombre
          }
          if (this.iconoActivo === 2) {
            holName = this.token.nombre
          }
          reservationRequest.creditCard.cardHoldersName = holName.toUpperCase();
          reservationRequest.creditCard.expirationMonth = month
          reservationRequest.creditCard.expirationYear = year
          reservationRequest.creditCard.paymentCardType = payCode
          reservationRequest.creditCard.token = this.credito.numero
          reservationRequest.creditCard.cardValidation = "true"
          reservationRequest.creditCard.tokenAction = ""

        }
        if(this.iconoActivo == 2) {
          var str = this.token.expiracion;
          var month = this.token.expiracion.substring(0, 2);
          var year = this.token.expiracion.substring(2);

          var payCode = ""
          for(var i = 0; i < this.token.tarjetas.length; i++) {
            if(this.token.tarjetas[i].nombre == this.token.tarjetaSeleccionada) {
              payCode = this.token.tarjetas[i].code
            }
          }

          reservationRequest.creditCard.cardHoldersName = this.token.nombre.toUpperCase();
          reservationRequest.creditCard.expirationMonth = month
          reservationRequest.creditCard.expirationYear = year
          reservationRequest.creditCard.paymentCardType = payCode
          reservationRequest.creditCard.token = this.token.numero
          reservationRequest.creditCard.cardValidation = "true"
          reservationRequest.creditCard.tokenAction = ""

        } if(this.iconoActivo == 0 || this.iconoActivo == 3 || this.iconoActivo == 4){
          reservationRequest.creditCard.cardHoldersName = ""
          reservationRequest.creditCard.expirationMonth = ""
          reservationRequest.creditCard.expirationYear = ""
          reservationRequest.creditCard.paymentCardType = ""
          reservationRequest.creditCard.token = ""
          reservationRequest.creditCard.cardValidation = "false"
          reservationRequest.creditCard.tokenAction = ""
        }
        var pM = ""
        switch(this.iconoActivo) {
          case 0:
            pM = "VO"
            break;
          case 1:
            pM = "CC"
            break;
          case 2:
            pM = "TK"
            break;
          case 3:
            pM = "DP"
            break;
          case 4:
            pM = "CXC"
            break;
          default:

            break;
        }
        reservationRequest.datos.paymentMethod = pM
        if(this.mergeUpdate) {

          var a = this.totalPreferencesRoomsWS.concat(this.totalPreferencesEWS)
          a.push(this.habitacion1.pickedFumar)
          a.push(this.habitacion1.pickedPiso)
          this.totalPreferences = a
          var textWS = []
          textWS.push(this.seeTextFloor)
          textWS.push(this.seeTextSmoke)
          for(var i = 0; i < a.length; i++) {
            for(var ii = 0; ii < this.habitacion1.typeRoomsPreferents.length; ii++) {
              if(a[i] == this.habitacion1.typeRoomsPreferents[ii].code) {
                textWS.push(this.habitacion1.typeRoomsPreferents[ii].name)
              }
            }
          }
          for(var i = 0; i < a.length; i++) {
            for(var ii = 0; ii < this.habitacion1.typeExtrasPreferents.length; ii++) {
              if(a[i] == this.habitacion1.typeExtrasPreferents[ii].code) {
                textWS.push(this.habitacion1.typeExtrasPreferents[ii].name)
              }
            }
          }
          var aO =  textWS.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
          this.textPref = aO.join(", ");
          this.ls.set('preTe', this.textPref)
          reservationRequest.profile[0].preferencias = this.totalPreferences
          reservationRequest.profile[0].preferenciasTexto = this.textPref

        }
        var filteredWS = reservationRequest.profile[0].preferencias.filter(function (el) {
          return el != null && el != "";
        });
        reservationRequest.profile[0].preferencias = filteredWS
        var pla = reservationRequest.profile[0].preferenciasTexto.startsWith(", ");
        if(pla) {
          var pla2 = reservationRequest.profile[0].preferenciasTexto.substr(2)
          reservationRequest.profile[0].preferenciasTexto = pla2
        }
        reservationRequest.updateRate = true
        if(this.iconoActivo == 1 || this.iconoActivo == 2) {
          var cardValidationW = "true"
        } else {
          var cardValidationW = "false"
        }
        reservationRequest.creditCard.cardValidation = String(cardValidationW)
        if(reservationRequest.creditCard.expirationYear.includes("/")) {
          var a = reservationRequest.creditCard.expirationYear.substr(1)
          reservationRequest.creditCard.expirationYear = a
        }
        this.ls.set('requirementsDataH1', reservationRequest.profile[0].preferenciasTexto)
        this.ls.set('fixA', true)
        if(reservationRequest.profile[0].preferencias[0] == "bajo") {
          reservationRequest.profile[0].preferencias.splice(0,1)
        }
// Setting motiva
        if(this.ls.get('motivaNumber') != "" && this.ls.get('motivaNumber') != null) {
          reservationRequest.datos.pif = this.ls.get('motivaNumber')
        }
// Setting motiva

        do {
          let index = reservationRequest.profile[0].preferencias.indexOf("");
          if (index > -1) {
            reservationRequest.profile[0].preferencias.splice(index, 1);
          }
        }
        while (reservationRequest.profile[0].preferencias.includes(""));

        reservationRequest.datos.cuponCXC = this.vaucher.folio

// Set up policieId
        var policieId = ""
        var razonKey = ''
         if (this.iconoActivo === 0) {
          for(var i = 0; i < this.vaucher.politicas.length; i++) {
              if(this.vaucher.politicaSeleccionada == this.vaucher.politicas[i].nombre) {
                policieId = this.vaucher.politicas[i].code
              } 
          }

          for(var i = 0; i < this.vaucher.razones.length; i++) {
            if(this.vaucher.razones[i].nombre == this.vaucher.razonSeleccionada) {
              razonKey = this.vaucher.razones[i].code
            }
          }
        }

        if (this.iconoActivo === 1) {
          for(var i = 0; i < this.credito.politicas.length; i++) {
            if(this.credito.politicaSeleccionada == this.credito.politicas[i].nombre) {
              policieId = this.credito.politicas[i].code
            } 
          }

          for(var i = 0; i < this.credito.razones.length; i++) {
            if(this.credito.razones[i].nombre == this.credito.razonSeleccionada) {
              razonKey = this.credito.razones[i].code
            }
          }
        }

        if (this.iconoActivo === 2) {
          for(var i = 0; i < this.token.politicas.length; i++) {
            if(this.token.politicaSeleccionada == this.token.politicas[i].nombre) {
              policieId = this.token.politicas[i].code
            } 
          }

          for(var i = 0; i < this.token.razones.length; i++) {
            if(this.token.razones[i].nombre == this.token.razonSeleccionada) {
              razonKey = this.token.razones[i].code
            }
          }
        }

        if (this.iconoActivo === 3) {
          for(var i = 0; i < this.tiempoLimite.politicas.length; i++) {
            if(this.tiempoLimite.politicaSeleccionada == this.tiempoLimite.politicas[i].nombre) {
              policieId = this.tiempoLimite.politicas[i].code
            } 
          }

          for(var i = 0; i < this.tiempoLimite.razones.length; i++) {
            if(this.tiempoLimite.razones[i].nombre == this.tiempoLimite.razonSeleccionada) {
              razonKey = this.tiempoLimite.razones[i].code
            }
          }
        }

        if (this.iconoActivo === 4) {
          for(var i = 0; i < this.creditoEmpresa.politicas.length; i++) {
            if(this.creditoEmpresa.politicaSeleccionada == this.creditoEmpresa.politicas[i].nombre) {
              policieId = this.creditoEmpresa.politicas[i].code
            } 
          }

          for(var i = 0; i < this.creditoEmpresa.razones.length; i++) {
            if(this.creditoEmpresa.razones[i].nombre == this.creditoEmpresa.razonSeleccionada) {
              razonKey = this.creditoEmpresa.razones[i].code
            }
          }
        }

        reservationRequest.datos.policieId = (policieId==='-1'?'':policieId)
        reservationRequest.datos.tradeName = (razonKey==='-1'?'':razonKey)
        if(this.ls.get('updateCostDetail').data.hotel.benefitsRestrictions == null || this.ls.get('updateCostDetail').data.hotel.benefitsRestrictions.rateDescription == null) {

          reservationRequest.datos.policieText = ""


        } else {
          reservationRequest.datos.policieText = this.ls.get('updateCostDetail').data.hotel.benefitsRestrictions.rateDescription;

        }
// Supplements
if(this.ls.get("rateDesEr") != null && this.ls.get("rateDesEr") != "") {
      reservationRequest.datos.briefDescription = this.ls.get("rateDesEr")
}

if(reservationRequest.profile[0].preferencias.includes(null)) {
  var filtered = reservationRequest.profile[0].preferencias.filter(function (el) {
  return el != null;
});
reservationRequest.profile[0].preferencias = filtered

}
var realOptional = []
if(this.listRequeOpcionalesSeleccionados.length != 0) {
  for(var i = 0; i < this.listRequeOpcionalesSeleccionados.length; i++) {
    realOptional.push(this.listRequeOpcionalesSeleccionados[i].reqOpcional)
  }
  reservationRequest.rateOptionalSupplementResponseList = realOptional
} else {
    reservationRequest.rateOptionalSupplementResponseList = []

}

// Adding optional rates
reservationRequest.rates.totalCost += this.totalCostWithSuppl 
reservationRequest.rates.totalTaxes += this.totalSupplTax 
reservationRequest.rates.totalSupplements += this.totalSuppAmou 
reservationRequest.rates.supplementTotalTaxes = this.totalSupplTax
// Adding optional rates
if(reservationRequest.rateOptionalSupplementResponseList.length == 0) {
    this.ls.set('opSuE', "")
}

        axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_RESERVATION , reservationRequest
          , {
            withCredentials: true,
            credentials: 'include',
            headers: {'Authorization': 'Bearer ' + token,
              'Content-Type' : 'application/json',
              'Accept-Language' : language.data
            }
          })

          .then(res => {
            this.changeLoader = false
            var ls = new SecureLS({encodingType: 'aes'});
            ls.set('responseReservation', {data: res.data.response})
            if(this.isVoucherPayment) {


              var metodosPagoData = {
                voucherFolio :  this.vaucher.folio,
                politicaSeleccionada: this.vaucher.politicaSeleccionada,
                razonSeleccionada: this.vaucher.razonSeleccionada,
                metodoPago: "Voucher",
                isCreditCard: 0

              }

              for(var i = 0; i < this.credito.politicas.length; i++) {
                if(metodosPagoData.politicaSeleccionada == this.credito.politicas[i].nombre) {
                  metodosPagoData.policieId = this.credito.politicas[i].code
                }
              }


            } if (this.isCreditCardPayment) {


              var metodosPagoData = {

                creditoTarjetaSeleccionada: this.credito.tarjetaSeleccionada,
                creditoTipoDeMascara : this.credito.tipoDeMascara,
                creditoNombre: this.credito.nombre,
                creditoExpiracion: this.credito.expiracion,
                politicaSeleccionada: this.credito.politicaSeleccionada,
                razonSeleccionada: this.credito.razonSeleccionada,
                metodoPago: "Tarjeta de Crédito",
                isCreditCard: 1,
                creditCardType: this.cardTypeForService


              }

              for(var i = 0; i < this.credito.politicas.length; i++) {
                if(metodosPagoData.politicaSeleccionada == this.credito.politicas[i].nombre) {
                  metodosPagoData.policieId = this.credito.politicas[i].code
                }
              }


            } if(this.isTokenPayment) {


              var metodosPagoData = {


                creditoTarjetaSeleccionada: this.token.tarjetaSeleccionada,
                creditoTipoDeMascara: this.token.numero,
                creditoNombre: this.token.nombre,
                creditoExpiracion : this.token.expiracion,
                creditoPoliticaSeleccionada: this.token.politicaSeleccionada,
                razonSeleccionada: this.token.razonSeleccionada,


                metodoPago: "Token",
                isCreditCard: 1,
                creditCardType: this.tokenCreditCardType



              }
            } if(this.isTimeLimitPayment) {
              var metodosPagoData = {


                politicaSeleccionada: this.tiempoLimite.politicaSeleccionada,
                razonSeleccionada: this.tiempoLimite.razonSeleccionada,
                metodoPago: "Tiempo límite",
                isCreditCard: 0



              }

              for(var i = 0; i < this.credito.politicas.length; i++) {
                if(metodosPagoData.politicaSeleccionada == this.credito.politicas[i].nombre) {
                  metodosPagoData.policieId = this.credito.politicas[i].code
                }
              }
            } if(this.isCreditPayment) {


              var metodosPagoData = {

                creditoEmpresaFolio: this.creditoEmpresa.folio,
                politicaSeleccionada: this.creditoEmpresa.politicaSeleccionada,
                razonSeleccionada: this.creditoEmpresa.razonSeleccionada,
                metodoPago: "Credito",
                isCreditCard: 0


              }

              for(var i = 0; i < this.credito.politicas.length; i++) {
                if(metodosPagoData.politicaSeleccionada == this.credito.politicas[i].nombre) {
                  metodosPagoData.policieId = this.credito.politicas[i].code
                }
              }

            }


            // Here I must add socialReason
            for(var i = 0; i < this.credito.razones.length; i++) {
              if(this.credito.razones[i].nombre == metodosPagoData.razonSeleccionada) {
                metodosPagoData.agencyKey = this.credito.razones[i].code
                metodosPagoData.agencyAddress = this.credito.razones[i].agencyAddress
                metodosPagoData.agencyPhone = this.credito.razones[i].agencyPhone
                metodosPagoData.agencyRFC = this.credito.razones[i].agencyRFC
                metodosPagoData.agencyType = this.credito.razones[i].agencyType
              }
            }

            //    this.findPaymentMethod

            if(metodosPagoData.metodoPago == 'Voucher') {
              metodosPagoData.paymentMethodForReservationRequest = 'VO'
            }

            if(metodosPagoData.metodoPago == 'Tarjeta de Crédito') {
              metodosPagoData.paymentMethodForReservationRequest = 'CC'
            }
            if(metodosPagoData.metodoPago == 'Token') {
              metodosPagoData.paymentMethodForReservationRequest = 'TK'
            }

            if(metodosPagoData.metodoPago == 'Credito') {
              metodosPagoData.paymentMethodForReservationRequest = 'CXC'
            }

            //  Starting limit time for reservation request
            if(metodosPagoData.metodoPago == 'Tiempo límite') {
              metodosPagoData.paymentMethodForReservationRequest = 'DP'
            }
            metodosPagoData.businessRa = this.businessRa

// Set policieText in confir
            metodosPagoData.creditoPoliticaSeleccionada = ""
            switch (this.iconoActivo) {
              case 0:
                if(this.vaucher.politicaSeleccionada != null && this.vaucher.politicaSeleccionada != "") {
                  metodosPagoData.creditoPoliticaSeleccionada = this.vaucher.politicaSeleccionada
                }
                break;
              case 1:
                if(this.credito.politicaSeleccionada != null && this.credito.politicaSeleccionada != "") {
                  metodosPagoData.creditoPoliticaSeleccionada = this.credito.politicaSeleccionada
                }
                break;
              case 2:
                if(this.token.politicaSeleccionada != null && this.token.politicaSeleccionada != "") {
                  metodosPagoData.creditoPoliticaSeleccionada = this.token.politicaSeleccionada
                }
                break;
              case 3:
                if(this.tiempoLimite.politicaSeleccionada != null && this.tiempoLimite.politicaSeleccionada != "") {
                  metodosPagoData.creditoPoliticaSeleccionada = this.tiempoLimite.politicaSeleccionada
                }
                break;
              case 4:
                if(this.creditoEmpresa.politicaSeleccionada != null && this.creditoEmpresa.politicaSeleccionada != "") {
                  metodosPagoData.creditoPoliticaSeleccionada = this.creditoEmpresa.politicaSeleccionada
                }
                break;
              default:
                break;
            }


// Set policieText in confir

            this.ls.set('metodosPagoData', {data: metodosPagoData})
            this.ls.set('preTe', "")
            this.ls.set('changeTitleMod', true)
            var datesA = {
              arrivalDate: this.arrivalDate,
              departureDate: this.departureDate
            }
            var updatedates = this.ls.get('datosHabHotSelected').data


            updatedates.habitacion.beautiDateInput = this.reA
            updatedates.habitacion.beautiDateOutput = this.reD
            updatedates.habitacion.totalAdults = this.adults
            updatedates.habitacion.totalChildren = this.minors
            updatedates.habitacion.totalInfants = this.infants
            // Adjust total stay cost
updatedates.hotel.negotiatedRatesDetailPrice.totalRateWithTaxes = this.totalCost + this.totalCostWithSuppl
            // Adjust total stay cost

            this.ls.set('datosHabHotSelected', {data:updatedates})
            var saveDataI = this.ls.get('availibilityRequest')
            saveDataI.data.discountCode = this.ls.get("disModDa")
            this.ls.set('opSuEList', this.listRequeOpcionalesSeleccionados)
            this.ls.set('availibilityRequest', saveDataI)
            this.$router.push({ name:'ReservacionesConfirmacion'})
          })
          .catch(error=>{
// Error server
            console.log(error)
            this.changeLoader = false;
          if (error.response.data.errorCode == 'RSP_HOTEL_AVAIL_06' || error.response.data.errorCode == 'RSP_HOTEL_AVAIL_07') {
            GlobalFunctions.cleanLocalStorageOfReserva();
            this.banError6 = true;
            this.error6Body = error.response.data.message;
          } else {
            if (error.response != undefined && error.response.status == 409 && error.response.data.errorCode == 'RSP_HOTEL_RESERV_1300') {
              this.modalNewBody = error.response.data.message;
              this.banNewModal = true;
            } else {
              if (error.response.status == 404 && error.response.data.errorCode == 'RSP_RESERV_SEARCH_CODE_03') {
                this.modalCautionBody = error.response.data.message;
                this.modalCaution = true;
              } else {
                if(  error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
                  this.$router.push({ name: "Error" });
                }
              }
            }

          }

          })
      },
      generalReset() {
        this.vaucher.folio = ""
        this.credito.tarjetaSeleccionada = ""
        this.credito.numero = ""
        this.credito.tipoDeMascara = ""
        this.credito.nombre= ""
        this.credito.expiracion = ""
        this.fechaExpiracionTarCred = ''
        this.token.tarjetaSeleccionada = ""
        this.token.numero = ""
        this.token.nombre = ""
        this.token.expiracion = ""
        this.fechaExpiracionToken = ''
        this.creditoEmpresa.folio = ""
      },
      cargaToken() {
        let urlToken = process.env.VUE_APP_TOKENIZER + this.ls.get('Language').data;
        this.urlTokenizado = urlToken;
        this.HTMLcontent = '<iframe id="iframeTokenizador" style="border: none; width: 100%; height: 380px;" src="'+ urlToken+'"></iframe>';

      },
      requestTokenizador(){
        return new Promise ((resolve, reject) => {
          let urlTokenizado = process.env.VUE_APP_TOKENIZER + this.ls.get('Language').data;
          window.addEventListener("message", function(event) {
            if ( urlTokenizado.startsWith(event.origin)) {
              this.credito.numero =  event.data;
              resolve(event.data);
            }else{
              reject(event);
            }
          });
        });
      },
      cerrarTokenizador(){
        this.HTMLcontent = '';
        this.modalTokenizador = false;
      },
      abrirTokenizador() {
        if (this.credito.tarjetaSeleccionada != '') {
          this.HTMLcontent= '';
          this.cargaToken();

          this.modalTokenizador = true;
          this.requestTokenizador().then(response=> {
            this.credito.numero = response;
            this.credito.tipoDeMascara = response;
            this.cerrarTokenizador();
          }).catch(error => {
            //error ___Tokenizador respondio null o undefined o vacio
          });
        }
      },
      defaultPayment() {
        this.iconoActivo = this.ls.get("paymentMethodRO").data.paymentMethod
        switch (this.iconoActivo) {
          case 0:
            // Data for read only reservation modification
            this.vaucher.folio = this.ls.get("paymentMethodRO").data.folio
            this.vaucher.politicaSeleccionada = this.ls.get("paymentMethodRO").data.politicaSeleccionada
            this.vaucher.razonSeleccionada = this.ls.get("paymentMethodRO").data.razonSocial
            this.ls.set("paymentMethodRO", {data: {
                folio: this.vaucher.folio,
                razonSocial: this.vaucher.razonSeleccionada ,
                politicaSeleccionada: this.vaucher.politicaSeleccionada,
                paymentMethod: 0
              }})
            this.sendVoucher()

            return this.visibleVoucher = true
            break;
          case 1:
            // Data for read only reservation modification
            this.credito.tarjetaSeleccionada = this.ls.get("paymentMethodRO").data.creditoCardType
            this.credito.numero = this.ls.get("paymentMethodRO").data.creditoNumber
            this.credito.tipoDeMascara = this.ls.get("paymentMethodRO").data.creditoMask
            this.credito.nombre = this.ls.get("paymentMethodRO").data.creditoName
            this.credito.expiracion = this.ls.get("paymentMethodRO").data.creditoExpire
            this.fechaExpiracionTarCred = this.ls.get("paymentMethodRO").data.creditoExpire
            this.credito.politicaSeleccionada = this.ls.get("paymentMethodRO").data.creditoPolicy
            this.credito.razonSeleccionada = this.ls.get("paymentMethodRO").data.creditoSocial
            this.ls.set("paymentMethodRO", {data: {
                creditoCardType :this.credito.tarjetaSeleccionada,
                creditoNumber :this.credito.numero,
                creditoMask :this.credito.tipoDeMascara,
                creditoName :this.credito.nombre,
                creditoExpire :this.credito.expiracion,
                creditoPolicy :this.credito.politicaSeleccionada,
                creditoSocial :this.credito.razonSeleccionada,
                paymentMethod: 1
              }})
            this.sendCreditCard()
            setTimeout(() => {
              this.modalToken(3);

            }, 5000);

            return this.visibleTC = true
            break;
          case 2:
            // Token  not needed cuz by default Token will never be open by default as
            // the default payment methods when starting up this component
            this.token.tarjetaSeleccionada = this.ls.get("paymentMethodRO").data.tokenTarjetaSeleccionada
            this.token.numero = this.ls.get("paymentMethodRO").data.tokenNumero
            this.token.nombre = this.ls.get("paymentMethodRO").data.tokenNombre
            this.token.expiracion = this.ls.get("paymentMethodRO").data.tokenExpiracion
            this.fechaExpiracionToken = this.ls.get("paymentMethodRO").data.tokenExpiracion
            this.token.politicaSeleccionada = this.ls.get("paymentMethodRO").data.tokenPoliticaSeleccionada
            this.token.razonSeleccionada = this.ls.get("paymentMethodRO").data.tokenRazonSeleccionada
            this.ls.set("paymentMethodRO", {data: {
                tokenTarjetaSeleccionada: this.token.tarjetaSeleccionada,
                tokenNumero: this.token.numero,
                tokenNombre: this.token.nombre,
                tokenExpiracion: this.token.expiracion,
                tokenPoliticaSeleccionada: this.token.politicaSeleccionada,
                tokenRazonSeleccionada: this.token.razonSeleccionada,
                paymentMethod: 2
              }})
            this.sendToken()
            return this.visible = true
            break;
          case 3:
            // Data for read only reservation modification
            this.tiempoLimite.politicaSeleccionada = this.ls.get("paymentMethodRO").data.tiempoPolitica
            this.tiempoLimite.razonSeleccionada = this.ls.get("paymentMethodRO").data.tiempoRazon
            this.ls.set("paymentMethodRO", {data: {
                tiempoPolitica: this.tiempoLimite.politicaSeleccionada,
                tiempoRazon: this.tiempoLimite.razonSeleccionada,
                paymentMethod: 3
              }})
            this.sendTimeLimit()

            return this.visibleLimit = true
            break;
          case 4:
            // Data for read only reservation modification
            this.creditoEmpresa.folio = this.ls.get("paymentMethodRO").data.creditFolio
            this.creditoEmpresa.politicaSeleccionada = this.ls.get("paymentMethodRO").data.creditPolicy
            this.creditoEmpresa.razonSeleccionada = this.ls.get("paymentMethodRO").data.creditReason
            this.ls.set("paymentMethodRO", {data: {
                creditFolio: this.creditoEmpresa.folio,
                creditPolicy: this.creditoEmpresa.politicaSeleccionada,
                creditReason: this.creditoEmpresa.razonSeleccionada,
                paymentMethod: 4
              }})
            this.sendCreditPay()

            return this.visibleCredit = true
            break;
          default:
            return null
            break;
        }
      },
      closeExpiredModal() {
        this.isExpiredModalVisible = false;
        GlobalFunctions.localStorageClean();
        this.$router.push({ name: "Login" });
      },
      consultaMetodosPago() {
        const userProperties = this.ls.get('userProperties');

        var dataMetPag = {
          hotelCode: null,
          arrivalDate: null,
          departureDate: null,
          currencyCode: null,
          contractCode: null,
          contractType: null,
          agreementCode: null,
          iataCode: null,
          motivaCode: null,
          userProperties: [],
        };
        dataMetPag.agreementCode = ""
        dataMetPag.arrivalDate = this.ls.get("arrivalDateReadOnly")
        dataMetPag.departureDate = this.ls.get("departureDateReadOnly")
        dataMetPag.hotelCode = this.ls.get("hotelCodeROWS");
        this.getRequirements()

        dataMetPag.currencyCode = this.currencyCode;
        dataMetPag.contractCode = this.ls.get("contractCodeROWS");
        dataMetPag.contractType = this.ls.get("contractTypeRO")
        dataMetPag.iataCode = ""
        dataMetPag.motivaCode = this.ls.get("motivaReadOnly")
        var userPropertiesTemp = [];
        for(var usProp of userProperties.data) {
          userPropertiesTemp.push(Number(usProp.propertyId))
        }

        dataMetPag.userProperties = userPropertiesTemp.sort().join();

        GlobalServices._consultaMetodosPagos(dataMetPag, this.ls.get('Token').data, this.ls.get('Language').data).then(responseMetPag => {
          var listTarjTemp = [];
          for (var res of responseMetPag.data.paymentCardTypeResponseList) {
            if (res.paymentCardType.toLowerCase() === 'amexco') {
              listTarjTemp.push({ nombre: res.paymentCardName, tipoT: 1, code: res.paymentCardType});
            }
            if (res.paymentCardType.toLowerCase() === 'diners') {
              listTarjTemp.push({ nombre: res.paymentCardName, tipoT: 2, code: res.paymentCardType});
            }
            if (res.paymentCardType.toLowerCase() === 'master') {
              listTarjTemp.push({ nombre: res.paymentCardName, tipoT: 3, code: res.paymentCardType});
            }
            if (res.paymentCardType.toLowerCase() === 'visa') {
              listTarjTemp.push({ nombre: res.paymentCardName, tipoT: 4, code: res.paymentCardType});
            }
          }
          this.credito.tarjetas = listTarjTemp;
          this.token.tarjetas = listTarjTemp;

          if (responseMetPag.data.paymentMethodTypeResponseList === 0) {
            this.banVaucher = false;
            this.banTarjCred = false;
            this.banToken = false;
            this.banTiemLim = false;
            this.banCredito = false;
          } else{
            for (var res1 of responseMetPag.data.paymentMethodTypeResponseList) {
              if (res1.paymentMethodType.toLowerCase() === 'vo') {
                this.banVaucher = true;
              }
              if (res1.paymentMethodType.toLowerCase() === 'cc') {
                this.banTarjCred = true;
              }
              if (res1.paymentMethodType.toLowerCase() === 'tk') {
                this.banToken = true;
              }
              if (res1.paymentMethodType.toLowerCase() === 'dp') {
                this.banTiemLim = true;
              }
              if (res1.paymentMethodType.toLowerCase() === 'cxc') {
                this.banCredito = true;
              }
            }
          }
        }).catch(error => {
                              // Error server
 if( (error.status == 404 && (error.errorCode == "RSP_LIFERAY_PARSE_01" || error.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.status == 500 || error.status == 502 || error.status == 503 || error.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
          if (error.status === 401) {
            this.clearLocalStorage();
          }
        });

      },
      clearLocalStorage() {
        this.isExpiredModalVisible = true;
      },
      politicaViajeRazonSocial(){
        const profile = this.ls.get('Profile').data;
        var dataPoliticas = {
          userType: profile.userType,
          contractType: this.ls.get('contractTypeRO'),
          discountCode: this.ls.get('discountCodeRO')
        };
        GlobalServices._consultaPoliticasViaje(dataPoliticas, this.ls.get('Token').data, this.ls.get('Language').data).then(reponsePoliticas => {
          var listTemp = [];
          for (let  pol of reponsePoliticas.data) {
            listTemp.push({ nombre: pol.policyName, code: pol.policyCode});
          }
          this.vaucher.politicas = listTemp;
          this.credito.politicas = listTemp;
          this.tiempoLimite.politicas = listTemp;
          this.creditoEmpresa.politicas = listTemp;
          this.token.politicas = listTemp;
          this.politicasList = listTemp;
          this.politicaSelectedDefault(listTemp);
        }).catch(error => {
                              // Error server
 if( (error.status == 404 && (error.errorCode == "RSP_LIFERAY_PARSE_01" || error.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.status == 500 || error.status == 502 || error.status == 503 || error.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
          if (error.status === 401) {
            this.clearLocalStorage();
          }
        });

        //Start KB44128 
        var contractTypeProfile = "";
        if (profile.profileId == "POSADAS" ){
          contractTypeProfile= "1";
        }else{
          contractTypeProfile=this.hotelReservationByCode.roomContractTypeCode;
        }

        var dataRazones = {
          iata: this.ls.get('iataL'),
          agreement: this.ls.get('agreementL'),
          discount: this.ls.get('discountCodeRO'),
          showINT: false,
          contractType: contractTypeProfile
        //End KB44128 
        };


        GlobalServices._consultaRazonesSociales(dataRazones, this.ls.get('Token').data, this.ls.get('Language').data).then(responseRazones => {
          var listTemp = [];
          for (let raz of responseRazones.data) {
            listTemp.push({razonSe: raz.agencyBusinessName, nombre: raz.agencyName, code: raz.agencyKey, agencyAddress: raz.agencyAddress, agencyPhone: raz.agencyPhone, agencyRFC: raz.agencyRFC, agencyType: raz.agencyType});
          }
          this.vaucher.razones = listTemp;
          this.credito.razones = listTemp;
          this.tiempoLimite.razones = listTemp;
          this.creditoEmpresa.razones = listTemp;
          this.token.razones = listTemp;
          this.razonSelectedDefault(listTemp);
        }).catch(error => {
                              // Error server
 if( (error.status == 404 && (error.errorCode == "RSP_LIFERAY_PARSE_01" || error.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.status == 500 || error.status == 502 || error.status == 503 || error.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
          if (error.status === 401) {
            this.clearLocalStorage();
          }
        });
      },
      politicaSelectedDefault(listPoliticas){
        if (listPoliticas.length > 0) {
          this.politicaSelectedDefault2(listPoliticas);
          for (var list of listPoliticas) {
            if (list.code === '-1') {
              this.banPoliticaSelectedDefault = true;
              this.vaucher.politicaSeleccionada = list.nombre;
              this.vaucher.politicaSeleccionadaCode = '-1';

              this.creditoEmpresa.politicaSeleccionada = list.nombre;
              this.creditoEmpresa.politicaSeleccionadaCode = '-1';

              this.credito.politicaSeleccionada = list.nombre;
              this.tiempoLimite.politicaSeleccionada = list.nombre;
              this.token.politicaSeleccionada = list.nombre;

              this.banSelectedPoliticaVaucher =  true;
              this.banSelectedPoliticaCredito =  true;
              this.banSelectedPoliticaToken = true;
              this.banSelectedPoliticaCreditoEmpresa =  true;
              this.banSelectedPoliticaTiempoLimite =  true;
            }
          }
        }
      },
      razonSelectedDefault(listRazones){
        if (listRazones.length > 0) {
          this.razonSelectedDefault2(listRazones);
          for (var list of listRazones) {
               //Inicio KB25711-26937
          //Responsable: Denise Mendez
          //Seleccionar razon social seleccionada en la creacion
              if(this.hotelReservationByCode.socialReasonResponse != null 
            		  && this.hotelReservationByCode.socialReasonResponse.agencyName === list.nombre){
                this.vaucher.razonSeleccionada = list.nombre;
                this.vaucher.razonSeleccionadaCode = list.code;

                this.creditoEmpresa.razonSeleccionada = list.nombre;
                this.creditoEmpresa.razonSeleccionadaCode = list.code;

                this.credito.razonSeleccionada = list.nombre;
                this.tiempoLimite.razonSeleccionada = list.nombre;
                this.token.razonSeleccionada = list.nombre;

                 this.banRazonSelectedDefault = true;
              }
              //Fin KB25711-26937
            if (!this.banRazonSelectedDefault) {  //Inicio KB25711-26937 prevenir seleccion Ninguna
              if (list.code === '-1') {
                this.banRazonSelectedDefault = true;
                this.vaucher.razonSeleccionada = list.nombre;
                this.vaucher.razonSeleccionadaCode = '-1';

                this.creditoEmpresa.razonSeleccionada = list.nombre;
                this.creditoEmpresa.razonSeleccionadaCode = '-1';

                this.credito.razonSeleccionada = list.nombre;
                this.tiempoLimite.razonSeleccionada = list.nombre;
                this.token.razonSeleccionada = list.nombre;
              }
            } //Fin KB25711-26937
          }
        }
      },
      politicaSelectedDefault2(listPoliticas){
        if (listPoliticas.length === this.contPoliticaSelectedDefault) {
          if (!this.banPoliticaSelectedDefault) {
            this.vaucher.politicaSeleccionada = listPoliticas[0].nombre;
            this.vaucher.politicaSeleccionadaCode = listPoliticas[0].code;

            this.creditoEmpresa.politicaSeleccionada = listPoliticas[0].nombre;
            this.creditoEmpresa.politicaSeleccionadaCode = listPoliticas[0].code;

            this.credito.politicaSeleccionada = listPoliticas[0].nombre;
            this.tiempoLimite.politicaSeleccionada = listPoliticas[0].nombre;
            this.token.politicaSeleccionada = listPoliticas[0].nombre;

            this.banSelectedPoliticaVaucher =  true;
            this.banSelectedPoliticaCredito =  true;
            this.banSelectedPoliticaToken = true;
            this.banSelectedPoliticaCreditoEmpresa =  true;
            this.banSelectedPoliticaTiempoLimite =  true;
          }
        } else {
          setTimeout(() => {
            this.politicaSelectedDefault2(listPoliticas);
            this.contPoliticaSelectedDefault++;
          }, 10);
        }
      },
      razonSelectedDefault2(listRazon){
        if (listRazon.length === this.contRazonSelectedDefault) {
          if (!this.banRazonSelectedDefault) {
            this.vaucher.razonSeleccionada = listRazon[0].nombre;
            this.vaucher.razonSeleccionadaCode = listRazon[0].code;

            this.creditoEmpresa.razonSeleccionada = listRazon[0].nombre;
            this.creditoEmpresa.razonSeleccionadaCode = listRazon[0].code;

            this.credito.razonSeleccionada = listRazon[0].nombre;
            this.tiempoLimite.razonSeleccionada = listRazon[0].nombre;
            this.token.razonSeleccionada = listRazon[0].nombre;
          }
        } else {
          setTimeout(() => {
            this.razonSelectedDefault2(listRazon);
            this.contRazonSelectedDefault++;
          }, 10);
        }
      },
      
    settingSuppl(resObject) {
this.ls.set('generalUp', true)
var toS = 0
var toIm = 0
for(var i=0; i < resObject.rateOptionalSupplementResponseList.length; i++) {
    toS += resObject.rateOptionalSupplementResponseList[i].amount
    for(var j = 0; j < resObject.rateOptionalSupplementResponseList[i].rateSupplementTaxesResponseList.length; j++) {
            if(resObject.rateOptionalSupplementResponseList[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                toIm += resObject.rateOptionalSupplementResponseList[i].rateSupplementTaxesResponseList[j].taxAmount

            }}
}
this.ls.set('generalSuppl', toS)
this.ls.set('generalSupplIm', toIm)

var extraSupE = 0
var extraSupIE = 0
var extraToSE = 0 

var extraSupEFirstNight = 0
var extraSupIEFirstNight = 0
var extraToSEFirstNight = 0 
var ob = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
 var ob2 = {
            extraSupE: extraSupEFirstNight,
            extraSupIE: extraSupIEFirstNight,
            extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', ob2)
       
        this.ls.set('supleCondi', ob)
        

if(resObject.numberOfNights != null && resObject.numberOfNights != "") {

    var numNuits = resObject.numberOfNights
} else {
    var numNuits = 1
}
if(resObject.rateOptionalSupplementResponseList != null && resObject.rateOptionalSupplementResponseList.length != 0) {
var suplObject = resObject.rateOptionalSupplementResponseList
for(var i=0; i < suplObject.length; i++) {
switch(suplObject[i].quantityType) {
    case 5:
        extraSupE += suplObject[i].amount / numNuits
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

            }
        }
        extraToSE += (extraSupIE + extraSupE)
        var obje = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
        this.ls.set('supleCondi', obje)
        break;

    case 3:
        extraSupE += suplObject[i].amount / numNuits
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

            }
        }
        extraToSE += (extraSupIE + extraSupE)
        var obje = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
        this.ls.set('supleCondi', obje)
        
        break;
        
    case 8:
        extraSupE += suplObject[i].amount / numNuits
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

            }
        }
        extraToSE += (extraSupIE + extraSupE)
        var obje = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
        this.ls.set('supleCondi', obje)
        
        break;

        
    case 6:
        extraSupE += suplObject[i].amount / numNuits
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

            }
        }
        extraToSE += (extraSupIE + extraSupE)
        var obje = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
        this.ls.set('supleCondi', obje)
        
        break;

        case 2:
        extraSupEFirstNight += suplObject[i].amount 
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIEFirstNight += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount 

            }
        }
        extraToSEFirstNight += (extraSupIEFirstNight + extraSupEFirstNight)
        var obje = {
            extraSupE: extraSupEFirstNight,
            extraSupIE: extraSupIEFirstNight,
            extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', obje)
        
            break;

        case 4:
                 extraSupEFirstNight += suplObject[i].amount 
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIEFirstNight += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount 

            }
        }
        extraToSEFirstNight += (extraSupIEFirstNight + extraSupEFirstNight)
        var obje = {
            extraSupE: extraSupEFirstNight,
            extraSupIE: extraSupIEFirstNight,
            extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', obje)
            break;
        
    default:
        break;
} 

}
}

    },
      details() {
        var a = this.ls.get("updateCostDetail")
        a.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes = this.totalCostWithSuppl
        this.ls.set("updateCostDetail", a)
    // Sending only the selected supplements
    var dataE = {
      rateOptionalSupplementResponseList : [],
      numberOfNights: this.nights
    }  
    if(this.listRequeOpcionalesSeleccionados.length != 0) {
    for(var i = 0; i < this.listRequeOpcionalesSeleccionados.length; i++) {
          dataE.rateOptionalSupplementResponseList.push(this.listRequeOpcionalesSeleccionados[i].reqOpcional)
    }
    } 
    this.settingSuppl(dataE)
    // Sending only the selected supplements

      this.componentKey += 1;
      
        setTimeout(() => {
          this.$bvModal.show('detalleDeCosto1');
        }, 1);
      },
      // buscador
      filteredListRazonesVoucher() {
        return this.vaucher.razonesLista = this.vaucher.razones
      },
      filteredListPoliticasVoucher() {
        return this.vaucher.politicasLista = this.vaucher.politicas
      },
      filteredListRazonesCredito() {
        return this.credito.razonesLista = this.credito.razones
      },
      filteredListPoliticasCredito() {
        return this.credito.politicasLista = this.credito.politicas
      },
      filteredListRazonesToken() {
        return this.token.razonesLista = this.token.razones
      },
      filteredListPoliticasToken() {
        return this.token.politicasLista = this.token.politicas
      },
      filteredListRazonesTiempo() {
        return this.tiempoLimite.razonesLista = this.tiempoLimite.razones
      },
      filteredListPoliticasTiempo() {
        return this.tiempoLimite.politicasLista = this.tiempoLimite.politicas
      },
      filteredListRazonesCreditoEmpresa() {
        return this.creditoEmpresa.razonesLista = this.creditoEmpresa.razones
      },
      filteredListPoliticasCreditoEmpresa() {
        return this.creditoEmpresa.politicasLista = this.creditoEmpresa.politicas
      },
      filteredListCredito() {
        return this.credito.tarjetasLista = this.credito.tarjetas
      },
      filteredListToken() {
        return this.token.tarjetasLista = this.token.tarjetas
      },
      // Metodo de pago
      // buscador
      cambiaValuePoliticaVoucher(politica, code) {
        this.vaucher.politicaSeleccionadaCode = code;
        this.banSelectedPoliticaVaucher =  true;
        return this.vaucher.politicaSeleccionada = politica;
      },
      cambiaValueRazonVoucher(razon, code) {
        this.vaucher.razonSeleccionadaCode = code;
        return this.vaucher.razonSeleccionada = razon;
      },
      cambiaValuePoliticaCredito(politica) {
        this.banSelectedPoliticaCredito =  true;
        return this.credito.politicaSeleccionada = politica;
      },
      cambiaValueRazonCredito(razon) {
        return this.credito.razonSeleccionada = razon;
      },
      cambiaValuePoliticaToken(politica) {
        this.banSelectedPoliticaToken = true;
        return this.token.politicaSeleccionada = politica;
      },
      cambiaValueRazonToken(razon) {
        return this.token.razonSeleccionada = razon;
      },
      cambiaValuePoliticaTiempo(politica) {
        this.banSelectedPoliticaTiempoLimite =  true;
        return this.tiempoLimite.politicaSeleccionada = politica;
      },
      cambiaValueRazonTiempo(razon) {
        return this.tiempoLimite.razonSeleccionada = razon;
      },
      cambiaValuePoliticaCreditoEmpresa(politica, code) {
        this.creditoEmpresa.politicaSeleccionadaCode = code;
        this.banSelectedPoliticaCreditoEmpresa =  true;
        return this.creditoEmpresa.politicaSeleccionada = politica;
      },
      cambiaValueRazonCreditoEmpresa(razon, code) {
        this.creditoEmpresa.razonSeleccionadaCode = code;
        return this.creditoEmpresa.razonSeleccionada = razon;
      },
      cambiaCredito(tipoTarjeta) {
        return this.credito.tarjetaSeleccionada = tipoTarjeta;
      },
      cambiarMascara(tipoTarjeta) {
        switch (tipoTarjeta) {
          case 1:
            return this.credito.tipoDeMascara = '#### ###### #####'
            break;
          case 2:
            return this.credito.tipoDeMascara = '#### ###### ####'
            break;
          default:
            return this.credito.tipoDeMascara = '#### #### #### ####'
            break;
        }
      },
   changePolicy(policyDesc,rate, guion,rateActive,tCliente){
     
          if(policyDesc.includes(this.twoPolicy)||policyDesc.includes(this.twoPolicyEn)){         
            let rateUltimateTwo = this.average/this.noches;
            var twonoches= rateUltimateTwo*2;
            twonoches = twonoches.toFixed(2);
            policyDesc= policyDesc.replace(rate,`$${twonoches.toLocaleString('en')}`);        
        }else{ 
              let rateUltimate = this.average/this.noches;    
              rateUltimate = rateUltimate.toFixed(2);              
              var localeString = rateUltimate.toLocaleString('en');
              policyDesc= policyDesc.replace(rate,`$${rateUltimate.toLocaleString('en')}`);
        }
    
		if(tCliente=='pyp'||tCliente=='pypsa'){
        if(rateActive=="Tarifa Negociada"||rateActive=="Negotiated Rate"){
        policyDesc=policyDesc.replace(rate,guion);
        }
       policyDesc=policyDesc;
        return policyDesc+rateActive;
      }
	   return policyDesc;
	   },
      cambiaToken(tipoTarjeta) {
        return this.token.tarjetaSeleccionada = tipoTarjeta;
      },
      // Cerrar inputs
      outsideSearchPoliticaVoucher(e) {
        this.vaucher.tipoPolitica = false;
      },
      outsideSearchRazonVoucher(e) {
        this.vaucher.tipoRazon = false;
      },
      outsideSearchPoliticaCredito(e) {
        this.credito.tipoPolitica = false;
      },
      outsideSearchRazonCredito(e) {
        this.credito.tipoRazon = false;
      },
      outsideSearchPoliticaToken(e) {
        this.token.tipoPolitica = false;
      },
      outsideSearchRazonToken(e) {
        this.token.tipoRazon = false;
      },
      outsideSearchPoliticaTiempo(e) {
        this.tiempoLimite.tipoPolitica = false;
      },
      outsideSearchRazonTiempo(e) {
        this.tiempoLimite.tipoRazon = false;
      },
      outsideSearchPoliticaCreditoEmpresa(e) {
        this.creditoEmpresa.tipoPolitica = false;
      },
      outsideSearchRazonCreditoEmpresa(e) {
        this.creditoEmpresa.tipoRazon = false;
      },
      outsideCredito(e) {
        this.credito.tipoTarjeta = false;
      },
      outsideToken(e) {
        this.token.tipoTarjeta = false;
      },
    },
    filters: {
      resalt: function (value, valueFromSearch) {
        if (!value) return ''
        valueFromSearch != '' ? value = value.replace(valueFromSearch,
          '<span class="PC-text--semibold PC-color--colorBase2">' + valueFromSearch + '</span>'
        ) : value = value;
        return value;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/scss/config.scss';
  .oculto {
    display: none !important;
  }
  // estilos para IE
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .custom-IE {
      position: absolute;
      margin-top: -10px;
    }
  }
  .modify-reservation {
    max-width: 770px;
    width: 100%;
    .card-header {
      background-color: #d1ecf1;
    }
    .referencia {
      color: $colorBase2;
    }
  }
  .listIconModal,
  .info {
    font-size: 14px !important;
  }
  .buscadorCard {
    margin: 0 !important;
  }
  .tituloDatos {
    width: fit-content;
    cursor: pointer;
    font-weight: 500;
    margin-bottom: 0;
    display: flex;
    align-items: center;
  }
  .tituloDatos[aria-expanded="true"] {
    color: #0c5458;
  }
  .datos {
    width: 100%;
  }
  .pt-8 {
    hr {
      margin: 0;
    }
  }
  .contenidoSearchCard {
    position: relative;
    .search-iconsCards {
      position: absolute;
      left: 5px;
      margin-top: 9px;
      font-size: 18px;
      color: #005a83;
      height: 34px;
    }
    .elipseCards {
      padding-left: 35px !important;
    }
  }
  .contentContacto {
    display: flex;
    position: relative;
    min-height: 70vh;
  }
  i:before {
    margin-left: 0px !important;
  }
  i {
    font-size: 24px;
  }
  .navi {
    float: right;
    font-size: 20px !important;
  }
  .camposActive {
    color: #0c5458;
    font-weight: 500;
  }
  .card-deck:first-child {
    .card {
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  .card-deck:nth-child(n+2) {
    .card {
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
      border-top: none;
    }
  }
  .card-deck:last-child {
    .card {
      border-bottom-left-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
    }
  }
  .contacto {
    width: 100%;
    margin-top: 57px;
    padding-top: 32px;
    .card-body {
      min-height: 10px;
      .card-title {
        font-size: $font-size-large;
      }
    }
    .estancia {
      font-size: $font-size-biglarge;
      font-weight: bold;
    }
  }
  .cancelarReserva {
    .card-header {
      background-color: #d4edda;
      color: #006900;
    }
    .referencia {
      color: $colorBase2;
    }
  }
  .enlacesContacto {
    color: $colorBase2;
    font-weight: 500;
    .demo-icon {
      font-size: $font-size-biglarge;
    }
  }
  .infoResaltado {
    font-size: 14px;
    font-weight: 500;
  }
  .info {
    font-size: 14px;
  }
  .icon-info {
    font-size: 20px;
    color: #005a83;
  }
  .cardInfoRegistro {
    position: fixed;
    max-width: 290px;
  }
  .tituloInfo {
    font-size: 15px;
    font-weight: bold;
  }
  .parrafoInfo {
    font-size: 14px;
    font-weight: 500;
  }
  .infoHabitacion {
    font-size: 14px;
    font-weight: normal;
  }
  .demo-icon {
    font-size: 18px;
  }
  .moneda {
    font-size: 12px;
    font-weight: 500;
  }
  .enlaceDetalle {
    font-size: 14px;
    font-weight: 500;
    color: #005a83;
  }
  .notaAzul {
    color: $colorBase2;
    font-weight: 500;
  }
  .azul {
    color: #005a83;
    font-weight: 500;
  }
  .botonesInfo {
    left: 50%;
  }
  .numConfimacion {
    display: inline;
  }
  @media only screen and (max-width: 992px) {
    .botonesInfo {
      left: 0;
    }
    .numConfimacion {
      display: block;
    }
    .card-deck .card {
      margin-bottom: 0px;
    }
  }
</style>
